import React, { Component } from 'react';
import {
    NavBar,
    BreadCumb,
    TimeOut,
    ClosureModal,
    PdfViewer,
    CashCutModal,
    ListModal,
    ConsolidateDocsModal,
    AreYouAgreeModal,
    EditCutInventoryModal,
    MoneyMovements,
    RefMoveCashModal,
    AppsCashCuts,
    WarningModal
} from '../../components';
import { CashMovement, CutInventory, ItemCutInventory, NewOrderSales, PayMethodCounter } from '../../components/NewOrder';
import '../../css/tablesPOS.css';
import moment from "moment";
import config from "../../config";
import { connect } from 'react-redux';
import { DISPATCH_ID, CURRENCY, FORMAT_NUMBER, SYMBOL, development, Datos_Empresa, SERVICE_RESPONSE } from "../../libs/utils/Const";
import { ApiClient } from "../../libs/apiClient";
import { GeneralFunctions } from "../../components/index";
import $ from "jquery";
import TwoStepsVerificationInventoryModal from '../../components/TwoStepsVerificationInventoryModal';
import download from 'js-file-download';
import PendingCashCutModal from '../../components/PendingCashCutModal';
let _generalFunctions = new GeneralFunctions();
let apiClient = ApiClient.getInstance();

const months = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre"
];

class ClosuresView extends Component {

    constructor(props) {
        super(props);
        this.state = {
            TODAY: moment(new Date()).format('YYYY-MM-DD'),
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')),
            EmployeesCashCutReports: [],
            BranchOfficeCreditNotes: [],
            CommentCloseDoc: '',
            idWorkShift: '',
            initialDate: moment(new Date()).format('YYYY-MM-DD'),
            finalDate: moment(new Date()).format('YYYY-MM-DD'),
            BranchOfficeInvoices: [],
            docsToPrint: [],
            sendMailModel: {
                to: '',
                subject: '',
                docEntry: ''
            },
            users: [],
            userSearch: '',
            cashCutsRecords: [],
            showCashCutModal: true,
            cashCut: "",
            totalCashCut: 0,
            totalAmountSales: 0,
            numSalesCashCut: 0,
            objCharge: {},
            extraPaymentsCashCut: {},
            headerCashCut: {},
            moneyOuts: [],
            moneyEntries: [],
            printhide: true,
            FailCardCodes: [],
            BlindCutByIdSession: [],
            idSessionSelected: "",
            simulateResult: [],
            responseBOC: {
                IM: null,
                IC: null,
                CC: null,
                CM: null,
            },
            DocDate: moment(new Date()).format('YYYY-MM-DD'),
            MonthDocument: 0,
            typeUser: '1',
            showAreYouAgreeModal: false,
            showValidateCutInventory: false,
            optionModal: '',
            showEditCutInventoryModal: false,
            enableMoneyMovements: false,
            PaymentSaleModel: new PayMethodCounter(),
            Action: 1,
            AvailablePayments: [],
            newOrderModel: new NewOrderSales(),
            addingMove: true,
            cashMovementModel: new CashMovement(),

            showRefMoveCashModal: false,

            Movements: [],
            optionSearchMovements: 1,
            showWarningModal: false,
            warningModel: {
                accept: () => { },
                cancel: () => $("#warningModal").modal("hide"),
            },
            currentCashCut: null,
            bankOptions: [],
            showValidateCreditOperations: false,
            showDepositOperations: true,
            authorizationCode: null,
        }
    }

    componentDidMount = async () => {
        await this.EmployeesCashCutReports();
        await this.SearchBranchOfficeInvoices();
        await this.GetUSers(1);
        await this.SetCurrentMonth();
        await this.SetBranchOfficeInfo();
        await this.searchBanksOptions();
    }

    SetCurrentMonth = async () => {
        const today = new Date();
        this.setState({
            MonthDocument: today.getMonth() ?? 1
        })
    }

    ChangeDocDate = value => {
        this.setState({ DocDate: value })
    }


    GetUSers = async (typeUser) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props
        const { _user } = this.state
        const data = {
            codeBO: _user?.Branch.CodeBranchOffice,
            typeUser,
        }
        enableSpinner(true);
        const responseApi = await apiClient.getSellersByBO(data);
        enableSpinner(false);
        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
            return
        }

        this.setState({
            users: responseApi.data || []
        })
    }

    ChangeInitialDate = async (event) => {
        let initialDate = event.target.value;
        await this.setState({
            initialDate,
        });
    };

    ChangeFinalDate = async (event) => {
        let finalDate = event.target.value;
        await this.setState({
            finalDate,
        });
    };

    ValidateInitialDate = () => {
        const { initialDate, finalDate, TODAY } = this.state;

        if (!initialDate) {
            this.setState({
                initialDate: TODAY
            });
            return;
        }

        if (finalDate && initialDate > finalDate) {
            this.setState({
                initialDate: TODAY
            });
        }
    };

    ValidateFinalDate = () => {
        const { initialDate, finalDate, TODAY } = this.state;

        if (!finalDate) {
            this.setState({
                finalDate: TODAY
            });
            return;
        }

        if (initialDate && finalDate < initialDate) {
            this.setState({
                finalDate: TODAY
            });
        }
    };

    ChangeCommentCloseDoc = async (value) => {
        await this.setState({ CommentCloseDoc: value })
    }

    ChangeTypeUser = async (value) => {
        this.setState({
            typeUser: value,
            userSearch: '',
            cashCutsRecords: [],
        })
        await this.GetUSers(value);
    }

    ChangeUserToSearch = async (value) => {
        this.setState({ userSearch: value })
    }

    EmployeesCashCutReports = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { _user } = this.state

        if (_user?.Branch.CodeBranchOffice === '' && _user?.Branch.CodeBranchOffice === undefined) return
        const data = {
            CodeBranchOffice: _user?.Branch.CodeBranchOffice
        };
        enableSpinner(true);
        let responseApi = await apiClient.BranchOfficeEmployeesCut(data);
        enableSpinner(false);
        // #consolidateDocsModal

        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
            return
        }
        this.setState({
            EmployeesCashCutReports: responseApi.data || []
        })
    }

    CheckWorkSession = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        enableSpinner(true);
        let responseApi = await apiClient.checkWorkSession();
        enableSpinner(false);
        if (responseApi.status === 1) {
            if (!responseApi.data.sessionStatus) {
                await this.ShowInitialCash();
            } else {
                this.setState({ idWorkShift: responseApi.data.idSession });
            }
        } else if (responseApi.status === 2) {
            showAlert({ type: "info", message: `${responseApi.message}`, timeout: 10000 });
            this.GotoDashboard();
        }
    };

    GotoDashboard = () => {
        this.props.history.push("/");
    };

    BranchOfficeGeneralCut = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { _user, CommentCloseDoc, MonthDocument, DocDate } = this.state
        const data = {
            CodeBranchOffice: _user?.Branch.CodeBranchOffice,
            CommentCloseDoc: CommentCloseDoc,
            CutDate: MonthDocument,
            DocDate: DocDate,
            idWorkShift: 0
        }

        enableSpinner(true);
        const responseApiCBO = await apiClient.BranchOfficeGeneralCut(data);
        enableSpinner(false);
        if (responseApiCBO.status !== 1) {
            if (responseApiCBO.status === 2) {
                showAlert({ type: "warning", message: responseApiCBO.message, timeOut: 99999 });
                await this.setState({
                    FailCardCodes: responseApiCBO.data || []
                })
                $("#failCardCodes").modal("show");
            } else {
                showAlert({ type: "error", message: responseApiCBO.message });
                return
            }
        }

        if (responseApiCBO.data.responseIC) {
            if (responseApiCBO.data.responseIC.status !== 1) {
                showAlert({ type: "info", message: responseApiCBO.data.responseIC.message, timeout: 999999 });
            } else {
                showAlert({ type: "success", message: responseApiCBO.data.responseIC.message, timeout: 999999 });
            }
        }
        if (responseApiCBO.data.responseIM) {
            if (responseApiCBO.data.responseIM.status !== 1) {
                showAlert({ type: "info", message: responseApiCBO.data.responseIM.message, timeout: 999999 });
            } else {
                showAlert({ type: "success", message: responseApiCBO.data.responseIM.message, timeout: 999999 });
            }
        }
        if (responseApiCBO.data.responseCC) {
            if (responseApiCBO.data.responseCC.status !== 1) {
                showAlert({ type: "info", message: responseApiCBO.data.responseCC.message, timeout: 999999 });
            } else {
                showAlert({ type: "success", message: responseApiCBO.data.responseCC.message, timeout: 999999 });
            }
        }
        if (responseApiCBO.data.responseCM) {
            if (responseApiCBO.data.responseCM.status !== 1) {
                showAlert({ type: "info", message: responseApiCBO.data.responseCM.message, timeout: 999999 });
            } else {
                showAlert({ type: "success", message: responseApiCBO.data.responseCM.message, timeout: 999999 });
            }
        }

        this.setState({ CommentCloseDoc: '' })

    }

    SearchBranchOfficeInvoices = async (type) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { finalDate, initialDate, _user } = this.state
        let data = {
            initialDate,
            finalDate,
            CodeBranchOffice: _user?.Branch.CodeBranchOffice,
            type
        }
        enableSpinner(true);
        let responseApi = await apiClient.SearchBranchOfficeInvoices(data);
        enableSpinner(false);
        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: responseApi.message });
        }

        this.setState({
            BranchOfficeInvoices: responseApi.data || [],
        })
    }

    SearchBranchOfficeCreditNotes = async (type) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { finalDate, initialDate, _user } = this.state

        const data = {
            initialDate,
            finalDate,
            CodeBranchOffice: _user?.Branch.CodeBranchOffice,
            type
        }
        enableSpinner(true);
        let responseApi = await apiClient.SearchBranchOfficeCreditNotes(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: responseApi.message });
            return
        }

        this.setState({
            BranchOfficeCreditNotes: responseApi.data || [],
        })
    }

    ShowDetailInvoiceBO = async (folio) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        let data = {
            docsToPrintIds: [folio],
            typeDoc: 13
        }
        enableSpinner(true);
        let responseApi = await apiClient.getPrintDocsInfo(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
            // this.CloseCreatedInvoiceActions();
            return;
        }
        await this.setState({
            docsToPrint: responseApi.data ?? [],
            typeDocPrint: 'OINV',
            ordersToAction: folio,
            EnableEditButton: false,
        });
        // await this.ShowPDFViewer();
        $("#pdfViewer").modal("show");
    }

    ShowDetailCreditNoteBO = async (folio) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        let data = {
            docsToPrintIds: [folio],
            typeDoc: 14
        }
        enableSpinner(true);
        let responseApi = await apiClient.getPrintDocsInfo(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
            // this.CloseCreatedInvoiceActions();
            return;
        }
        await this.setState({
            docsToPrint: responseApi.data ?? [],
            typeDocPrint: 'ORIN',
            ordersToAction: folio,
            EnableEditButton: false,
        });
        // await this.ShowPDFViewer();
        $("#pdfViewer").modal("show");
    }

    CloseCreatedInvoiceActions = async () => {
        // 

    }

    ValidateSessions = async () => {
        const { notificationReducer: { showAlert } } = this.props;
        const { EmployeesCashCutReports } = this.state;

        if (EmployeesCashCutReports.length > 0) {
            let flag = false;
            for (let index = 0; index < EmployeesCashCutReports.length; index++) {
                const session = EmployeesCashCutReports[index];
                if (session.sessionStatus === 'O') {
                    flag = true;
                }
            }
            if (flag) {
                showAlert({ type: "error", message: `HAY SESIONES ACTIVAS. VERIFICA QUE EL CAJERO RESPONSABLE REALICE SU CORTE DE CAJA`, timeout: 10000 });
                return
            } else {
                $("#closureModal").modal("show");
            }
        } else {
            showAlert({ type: "info", message: `NO HAY SESIONES ACTIVAS EN TU SUCURSAL. NO PUEDES GENERAR CORTES`, timeout: 10000 });
            return
        }

    }

    SearchLastCashCuts = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props
        const { userSearch, finalDate, initialDate, typeUser } = this.state
        if (userSearch === '') {
            showAlert({ type: "error", message: `Aun no has seleccionado un usuario para a buscar.` });
            return
        }
        const data = {
            userSearch,
            initialDate,
            finalDate,
            typeUser,
        }

        enableSpinner(true);
        const responseApi = await apiClient.searchLastCashCuts(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
            return
        }

        this.setState({
            cashCutsRecords: responseApi.data || []
        })
    }

    ShowCashCutModal = async (idWorkShift, recordData, showDepositOperations = true) => {
        await new Promise(resolve => this.setState({ showDepositOperations }, resolve));
        await this.GetBoxCut(idWorkShift, recordData)
        $("#cashCutModal").modal("show");
    }

    GetBoxCut = async (idWorkShift, recordData) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        enableSpinner(true);
        const responseApi = await apiClient.partialCut(idWorkShift);
        enableSpinner(false);
        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
            return;
        }

        await this.setState({
            cashCut: responseApi.data.reportcashCut || "",
            totalCashCut: Number(responseApi.data.totalCashCut) || 0,
            totalAmountSales: Number(responseApi.data.totalAmountSales) || 0,
            numSalesCashCut: Number(responseApi.data.numSales) || 0,
            objCharge: responseApi.data.objCharge || {},
            extraPaymentsCashCut: responseApi.data.extraPayments,
            headerCashCut: recordData,
            moneyOuts: responseApi.data.moneyOuts,
            moneyEntries: responseApi.data.moneyEntries,
        });
        this.GetBlindCut(idWorkShift);
    };

    GetBlindCut = async (idWorkShift) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        enableSpinner(true);
        const responseApi = await apiClient.BlindCut(idWorkShift);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: "info", message: `${responseApi.message}` });
        }
        await this.setState({
            BlindCutByIdSession: responseApi.data.BlindCut || [],
        })
    }

    ShowDetailCutUser = async (idSession, date) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { typeUser } = this.state;
        const data = {
            idSession,
            typeUser
        }
        enableSpinner(true);
        const responseApi = await apiClient.DetailCutUser(data);
        enableSpinner(false);
        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
            return;
        }
        responseApi.data.Date = date;
        await this.setState({
            docsToPrint: [responseApi.data],
            typeDocPrint: 'RECU',
            // ordersToAction: folio,
            EnableEditButton: false,
            idSessionSelected: idSession
        });

        $("#pdfViewer").modal("show");
    }

    SearchLastBOEmployeesCashCuts = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props
        const { finalDate, initialDate, _user } = this.state
        const startDate = new Date(initialDate);
        const endDate = new Date(finalDate);
        const datesBetween = [];
        let simulateResult = [];
        let currentDate = startDate;

        enableSpinner(true);
        const responseApi = await apiClient.branchCashCutAction({ action: "list", startDate, endDate });
        if (responseApi.status !== SERVICE_RESPONSE.SUCCESS) {
            showAlert({ type: "error", message: responseApi.message || "Error al conectar con el servidor, intente más tarde" });
        }

        while (currentDate <= endDate) {
            datesBetween.push(new Date(currentDate).toISOString());
            currentDate.setDate(currentDate.getDate() + 1);
        }
        for (let index = 0; index < datesBetween.length; index++) {
            const dateData = datesBetween[index];
            const realDate = (dateData).split('T')
            const session = Array.isArray(responseApi?.data) ? responseApi.data.find(({ CreateDate, Status }) => CreateDate === realDate[0] && Status === "O") : {};
            const data = {
                folio: `${_user?.Branch.CodeBranchOffice}-${realDate[0] ?? ''}CS`,
                date: realDate[0],
                codeBO: _user?.Branch.CodeBranchOffice,
                IdSession: session?.IdSession || "0",
                Status: session?.Status || "C",
            }
            simulateResult.push(data);
        }

        enableSpinner(false);
        await this.setState({
            simulateResult
        })
    }

    GetCashCutBOByDate = async (date) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props
        const data = {
            date
        }
        enableSpinner(true);
        const responseApi = await apiClient.SearchLastBOEmployeesCashCuts(data);
        enableSpinner(false);
        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
            return;
        }

        await this.setState({
            docsToPrint: [responseApi.data] ?? [],
            typeDocPrint: 'BOECC',
            EnableEditButton: false,
            showPDFViewer: !this.state.showPDFViewer,
            ShowExtraActions: false
        })
        $("#pdfViewer").modal("show");
    }

    ApproveCut = async (idSession) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props
        const { typeUser } = this.state;

        enableSpinner(true);
        const responseApi = await apiClient.ApproveCashCut({ idSession, typeUser });
        enableSpinner(false);

        showAlert({ type: !responseApi?.status ? "error" : "success", message: responseApi?.message || "Ocurrió un error inesperado, vuelva a intentarlo en unos minutos", timeOut: 5000 });
        this.SearchLastCashCuts();
    }
    // Mandar token 
    Sendtoken = async (idSession) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props

        enableSpinner(true);
        const responseApi = await apiClient.ReqInventoryApproval({ idWorkShift: idSession });
        enableSpinner(false);

        showAlert({ type: !responseApi?.status ? "error" : "success", message: responseApi?.message || "Ocurrió un error inesperado, vuelva a intentarlo en unos minutos", timeOut: 5000 });
        this.SearchLastCashCuts();
    }

    // Consultar corte de inventario 
    ShowDetailCutInventory = async (idSession, date) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { typeUser } = this.state;
        const data = {
            idSession,
            typeUser
        }
        enableSpinner(true);
        const responseApi = await apiClient.DetailCutInventory(data);
        enableSpinner(false);
        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
            return;
        }
        responseApi.data.Date = date;
        await this.setState({
            docsToPrint: [responseApi.data],
            typeDocPrint: 'CUTINVENTORY',
            EnableEditButton: false,
            idSessionSelected: idSession
        });

        $("#pdfViewer").modal("show");
    }

    //#region ########## MAIL FUNCTIONS  #################################################

    RefreshSendMailModel = (sendMailModel) => {
        this.setState({ sendMailModel })
    }

    SendDocsByEmail = async (docsStruct) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { sendMailModel, docsToPrint, typeDocPrint } = this.state
        var value = docsStruct.innerHTML;
        var objToSend = JSON.stringify(value);
        let infoFolio = await _generalFunctions.getDocInfoByFolio(docsToPrint[0].docHeader.infoByFolio.folio ?? '')
        sendMailModel.docEntry = infoFolio.DocEntry

        let data = {
            sendMailModel,
            docsStruct: objToSend,
            typeDoc: typeDocPrint,
            objType: infoFolio.num,
            infoDoc: [{
                cardCode: docsToPrint[0].docHeader.responseHeader.CardCode ?? '',
                folio: docsToPrint[0].docHeader.infoByFolio.folio ?? ''
            }]
        }

        enableSpinner(true);
        let responseApi = await apiClient.SendPrintDocsByEmail(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message ?? ''}` });
            return;
        }
        showAlert({ type: "success", message: `${responseApi.message ?? ''}` });
    }

    OpenSendMailModal = () => {
        $("#pdfSendMailModal").modal("show");
    }
    //#endregion

    PrintEmployeesBOCut = async (scrt) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        enableSpinner(true);
        const responseApi = await apiClient.PrintEmployeesBOCutAll();
        enableSpinner(false);
        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message ?? ''}` });
            return;
        }

        await this.setState({
            docsToPrint: [responseApi.data] ?? [],
            typeDocPrint: (scrt ? 'SCRT' : 'BOECC'),
            EnableEditButton: false,
            showPDFViewer: !this.state.showPDFViewer,
            ShowExtraActions: false
        });
        $("#pdfViewer").modal("show");
    }

    ShowFormatToPrint = async () => {
        await this.setState({
            printhide: !this.state.printhide,
        });
    };

    ChangeAuthenticationCode = async (value) => {
        const { notificationReducer: { showAlert } } = this.props;
        if (value.length > 6) {
            showAlert({ type: 'error', message: 'El token de verificación solo debe de ser de 6 caracteres' });
            return;
        }
        this.setState({
            key: value
        })
    };

    ChangeAuthCodeCashCut = async (value) => {

        this.setState({
            authorizationCode: value
        })
    };
    validateAutCashCutCode = async (idSession) => {//V1 SIN CODIGO AUTORIZADOR
        // const { authorizationCode } = this.state
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        // if (authorizationCode.length != 5) {
        //     showAlert({ type: 'error', message: 'El código es inválido' });
        //     return;
        // }
        const data = {
            idSession
        }
        enableSpinner(true);
        const responseApi = await apiClient.setCashCutPending(data);
        enableSpinner(false);
        if (responseApi?.status == 1) {
            showAlert({ type: 'success', message: responseApi?.message ?? 'Correcto' });
            await this.SearchLastCashCuts();
        } else {
            const returnType = typeof responseApi.message;
            showAlert({ type: 'warning', message: returnType === 'string' ? responseApi.message : 'Token invalido' });
            return;
        }


    }
    ValidateAuthenticationCodeTwoSteps = async () => {
        const { key, idSessionSelected, cashCutsRecords } = this.state
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;

        if (key.length !== 6) {
            showAlert({ type: 'warning', message: 'El token de verificación debe de ser de 6 caracteres' });
            return;
        }

        const data = {
            action: 2,
            key: key.trim(),
            idSession: idSessionSelected,
        }

        enableSpinner(true);
        const responseApi = await apiClient.InventoryTwoSteps(data);
        enableSpinner(false);

        const returnType = typeof responseApi.message;

        if (responseApi.status !== 1) {
            showAlert({ type: 'error', message: returnType === 'string' ? responseApi.message : 'Token invalido' });
            return;
        }
        showAlert({ type: 'info', message: responseApi.message });

        const index = cashCutsRecords.findIndex(
            (item) => item.idSession === idSessionSelected
        );

        if (index !== -1) {
            cashCutsRecords[index].twoFACodeUsed = 'Y';
        }

        await this.setState({
            key: '',
            idSessionSelected: '',
            cashCutsRecords, // alteramos el campo twoFACodeUsed con el valor en Y para habilitar el boton de descargar corte de inventario
        })
        this.HideDynamicModal('TwoStepsInventory');
    };

    CloseActions = async () => {
        await this.setState({
            key: ''
        })
    };
    ClosePndCashCutModal = async () => {
        this.setState({
            authorizationCode: null
        })
    };

    ShowDynamicModal = async (idModal, idSession) => {
        $(`#${idModal}`).modal('show');

        await this.setState({
            idSessionSelected: idSession
        });
    }

    HideDynamicModal = (idModal) => {
        $(`#${idModal}`).modal('hide');
    }
    onChangeCashCut = (event) => {
        const { cashCutsRecords, idSessionSelected } = this.state
        const records = JSON.parse(JSON.stringify(cashCutsRecords))
        const findIndex = records.findIndex(cut => cut.idSession === idSessionSelected)
        if (findIndex != -1) {
            const value = event.nativeEvent.target.value;
            if (/^\d*\.?\d{0,6}$/.test(value)) {
                records[findIndex].U_RS_DENSIDAD = value
            }
        }
        this.setState({
            cashCutsRecords: records
        })
    }
    OpenAreYouAgreeModal = async (idSession) => {
        await this.setState({
            showAreYouAgreeModal: !this.state.showAreYouAgreeModal,
            // idSessionSelected: idSession, // se comenta para que no se sobreescriba el idSessionSelected cuando se abre el modal de revisar corte de inventario
            showValidateCutInventory: false,
        });

        $('#areYouAgreeModal').modal('show');
    };

    OpenAreYouAgreeModalCutInventory = async (idSession) => {
        await this.setState({
            showValidateCutInventory: !this.state.showValidateCutInventory,
            idSessionSelected: idSession,
            optionModal: 'CloseCutInventory',
        });

        $('#areYouAgreeModal').modal('show');
    };

    openValidateCreditOperations = async () => {
        await this.setState({
            showValidateCreditOperations: !this.state.showValidateCreditOperations,
        }, () => {
            $('#areYouAgreeModal').modal('show');
        }
        );
    };

    CloseShowAreYouAgreeModal = async () => {
        await this.setState({
            showAreYouAgreeModal: false,
            showValidateCutInventory: false,
            optionModal: '',
        });
    };

    CloseShowValidateCreditOperations = async (status = 0) => {
        await this.setState({
            showValidateCreditOperations: false,
            currentCashCut: null
        }, async () => {
            if (status) {
                await this.SearchLastCashCuts();
            }
        }
        );
    };

    ApproveCutInventory = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { idSessionSelected } = this.state;
        const { cashCutsRecords } = this.state;
        let cashCut = cashCutsRecords.find(({ idSession }) => Number(idSession) === Number(idSessionSelected));
        enableSpinner(true);
        const responseApi = await apiClient.ApproveCashCutInventory({ idSession: idSessionSelected, cashCut });
        enableSpinner(false);
        if (responseApi.status === SERVICE_RESPONSE.SUCCESS) {
            await this.setState({
                showAreYouAgreeModal: false,
                showValidateCutInventory: false,
                optionModal: '',
            });
            showAlert({ type: !responseApi?.status ? "error" : "success", message: responseApi?.message || "Ocurrió un error inesperado, vuelva a intentarlo en unos minutos", timeOut: 5000 });
            await this.SearchLastCashCuts();

            // open cashCutApps

            if (cashCut) {
                this.AppCashCut(cashCut);
            }
        } else {
            await this.SearchLastCashCuts();
            showAlert({ type: "error", message: responseApi?.message || "Error de conexión", timeOut: 5000 });
        }

    };

    CloseCashCut = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { currentCashCut } = this.state;
        enableSpinner(true);
        const responseApi = await apiClient.approveCashCutMVENTAS(currentCashCut);
        enableSpinner(false);

        showAlert({ type: !responseApi?.status ? "error" : "success", message: responseApi?.message || "Ocurrió un error inesperado, vuelva a intentarlo en unos minutos", timeOut: 8000 });
        await this.CloseShowValidateCreditOperations(responseApi?.status);
    };

    OpenEditModalCutInventory = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { idSessionSelected, typeUser, _user } = this.state;

        // Cargar los datos 
        const data = {
            idSession: idSessionSelected,
            typeUser
        }
        enableSpinner(true);
        const responseApi = await apiClient.GetEditCutInventory(data);
        enableSpinner(false);
        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
            return;
        }

        let newCutInventoryModel = new CutInventory();
        // Llenar series
        newCutInventoryModel.Series = responseApi.data.series.Series || 0;
        newCutInventoryModel.SeriesName = responseApi.data.series.SeriesName || '';
        newCutInventoryModel.NextNumber = responseApi.data.series.NextNumber || 0;
        // Llenar series

        // newCutInventoryModel.CountType = '1';
        // Asignar nombre del usuario que creara el recuento de inventario
        newCutInventoryModel.Taker1Type = 'User';
        newCutInventoryModel.TakerId = _user?.USERID || '';
        newCutInventoryModel.TakerName = _user?.U_NAME || '';
        // Asignar nombre del usuario que creara el recuento de inventario

        for (let index = 0; index < responseApi.data.inStock.length; index++) {
            const element = responseApi.data.inStock[index];
            let newItemCut = new ItemCutInventory();
            newItemCut.ItemCode = element.ItemCode || '';
            newItemCut.ItemDesc = element.ItemName || '';
            newItemCut.WhsCode = element.WhsCode || '';
            newItemCut.BinEntry = element.AbsEntry || '';
            newItemCut.BinCode = element.BinCode || '';
            newItemCut.InWhsQty = element.remainingQty || 0;
            newItemCut.CountQty = Number(element.remainingQty || 0).toFixed(4); // Se carga la cantidad que tiene la ubicación para no tener errores por parte del usuario
            // newItemCut.Difference = 0;
            newItemCut.UomCode = element.UomCode || '';
            newCutInventoryModel.Items.push(newItemCut);
        }

        await this.setState({
            showAreYouAgreeModal: false,
            showValidateCutInventory: false,
            optionModal: '',
            showEditCutInventoryModal: !this.state.showEditCutInventoryModal,
            newOrderModelCutInventory: newCutInventoryModel,
        });

        $('#EditCutInventoryModal').modal({ backdrop: 'static', keyboard: false }, 'show');
    };

    changeReference2 = async (event) => {
        const { newOrderModelCutInventory } = this.state;
        newOrderModelCutInventory.Ref2 = event.nativeEvent.target.value;
        await this.setState({
            newOrderModelCutInventory,
        });
    };

    changeCountQtyItem = async (event, index) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { newOrderModelCutInventory } = this.state;

        let quantity = event.nativeEvent.target.value;

        if (quantity.indexOf(" ") !== -1 || quantity.indexOf("-") !== -1) {
            showAlert({ type: 'warning', message: "Carácter no permitido" });
            return;
        }

        if (!isNaN(quantity) && quantity !== '') {
            newOrderModelCutInventory.Items[index].CountQty = quantity;
            newOrderModelCutInventory.Items[index].Difference = Number((Number(quantity) - Number(newOrderModelCutInventory.Items[index].InWhsQty)).toFixed(4));
        } else if (quantity === '') {
            newOrderModelCutInventory.Items[index].CountQty = '';
        }

        await this.setState({
            newOrderModelCutInventory,
        });
    };

    DownloadFiles = async (type, idSession) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;

        const data = {
            file: type,
            typeDoc: 'CutInventory',
            idSession,
        };
        enableSpinner(true);
        const responsePdf = await apiClient.DownloadFiles(data);
        enableSpinner(false);
        const getFieldName = responsePdf.headers.get('content-disposition');

        if (getFieldName !== null) {
            // Get File Name from HTTP header
            let start = getFieldName.indexOf("filename=") + 10;
            let end = getFieldName.indexOf('"', start);
            try {
                responsePdf.blob().then(blob => download(blob, getFieldName.slice(start, end)));
            } catch (e) {
                showAlert({ type: 'error', message: 'Error al traer PDF', timeOut: 5000 });
            }
        }
        else {
            showAlert({ type: 'error', message: 'No se encontró el archivo en su ruta', timeOut: 5000 });
        }
    };

    sendInventoryCountings = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { idSessionSelected, typeUser, newOrderModelCutInventory } = this.state;

        const data = {
            idSession: idSessionSelected,
            typeUser,
            newOrderModelCutInventory,
        }

        showAlert({ type: 'success', message: 'Creando recuento de inventario...', timeOut: 5000 });
        enableSpinner(true);
        const responseApi = await apiClient.CreateInventoryCountings(data);
        enableSpinner(false);

        showAlert({ type: !responseApi?.status ? "error" : "success", message: responseApi?.message || "Ocurrió un error inesperado, vuelva a intentarlo en unos minutos", timeOut: 5000 });

        if (responseApi.status !== 1) {
            return;
        }
        // Mandar a cerrar el corte y crear el PDF
        await this.ApproveCutInventory();
        // Cerrar el modal
        $('#EditCutInventoryModal').modal('hide');
        // reiniciar el mostrar los modales
        await this.setState({
            showAreYouAgreeModal: false,
            showValidateCutInventory: false,
            optionModal: '',
            showEditCutInventoryModal: false,
            newOrderModelCutInventory: new CutInventory(),
        });

    }

    ShowHideMoneyMovements = async (option) => {
        if (option) {
            await this.EnableMoneyMovementsModal();
            $("#moneyMovementsModal").modal("show");
        } else {
            $("#moneyMovementsModal").modal("hide");
            await this.EnableMoneyMovementsModal();
        }
    };

    EnableMoneyMovementsModal = async () => {
        await this.setState({
            enableMoneyMovements: !this.state.enableMoneyMovements
        })
    };

    ChangeActionMoneyMovements = async (value, idSession) => {
        await this.setState({
            Action: value,
            idSessionSelected: idSession,
        })
    };

    CancelMoneyMovement = async () => {
        const { newOrderModel } = this.state
        await this.setState({
            isCancel: true,
            DownPayments: [],
            CreditNotes: [],
            // Se agrego esto
            enableMoneyMovements: false,
        });
        newOrderModel.PaymentsToSale = [];
        newOrderModel.PaymentsToReturn = [];
        newOrderModel.TotalMoneyMovement = 0;
        this.RefreshOrder(newOrderModel);
        if (this.state.showBillModal === true) {
            await this.ShowBillModal();
        }
        // await this.RefreshTotal(newOrderModel);
        await this.SumOfAmounts();
    };

    RefreshOrder = async (newOrderModel) => {
        await this.setState({ newOrderModel });
    };

    SumOfAmounts = async () => {
        const { newOrderModel, PaymentSaleModel } = this.state;
        let totalAmount = 0;
        for (const payAdded of newOrderModel.PaymentsToSale) {
            if (Number(payAdded.TypeMethod) !== 117) {
                totalAmount = totalAmount + Number(payAdded.Amount);
            }
        }

        newOrderModel.TotalRecibido = totalAmount;
        newOrderModel.TotalRestante = totalAmount ? (totalAmount - newOrderModel.Total) > 0 ? totalAmount - newOrderModel.Total : 0 : 0;
        newOrderModel.RemainingAmount = parseFloat(Number(newOrderModel.Total) - Number(totalAmount)).toFixed(2);

        PaymentSaleModel.Amount = Number(newOrderModel.RemainingAmount)

        await this.RefreshOrder(newOrderModel);
        await this.RefreshPaymentSaleModel(PaymentSaleModel);
    };

    // QUITAR SI NO SE NECESITA TODO
    SetBranchOfficeInfo = async () => {
        const { _user } = this.state
        const auxArrayMethods = _user.Branch.PaymentMethods.slice() || [];
        // Solo efectivo 
        const efectivo = auxArrayMethods.find(method => method.name === 'EFECTIVO');
        // Esto esta en PointOfSaleView
        // const indexNC = auxArrayMethods.findIndex(object => { return object.code === 'NC'; });
        // if (indexNC !== -1) auxArrayMethods.splice(indexNC, 1);

        // const indexCD = auxArrayMethods.findIndex(object => { return object.code === 'CD'; });
        // if (indexCD !== -1) auxArrayMethods.splice(indexCD, 1);

        await this.setState({
            AvailablePayments: efectivo ? [efectivo] : [],
        })
    }

    searchBanksOptions = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        enableSpinner(true);
        let banksRes = await apiClient.getBanksOptions();
        enableSpinner(false);
        if (!banksRes?.status) {
            showAlert({ type: 'warning', timeOut: 5000, message: banksRes?.message || "Ocurrió un error al obtener el listado de bancos dispobiles para los depósitos" });
        } else {
            this.setState({
                bankOptions: banksRes?.data ?? []
            })
        }
    }

    AddMove = () => {
        this.setState({
            addingMove: !this.state.addingMove,
        });
    };

    //#region ########## MOVEMENTS CASH ##################################################
    RefreshCashMovementModel = (cashMovementModel) => {
        this.setState({
            cashMovementModel: cashMovementModel
        })
    };

    ShowCashInModal = (show) => {
        if (show) {
            $("#cashInModal").modal("show");
        } else {
            $("#cashInModal").modal("hide");
            this.setState({ cashMovementModel: new CashMovement() })
        }
    }

    ShowCashOutModal = async (show) => {
        if (show) {
            $("#cashOutModal").modal("show");
        } else {
            $("#cashOutModal").modal("hide");
            await this.setState({ cashMovementModel: new CashMovement() })
        }
    }

    ChangeComment = async (value) => {
        const { cashMovementModel } = this.state
        cashMovementModel.comment = value;
        await this.RefreshCashMovementModel(cashMovementModel)
    };
    //#endregion

    RefreshPaymentSaleModel = (PaymentSaleModel) => {
        this.setState({ PaymentSaleModel })
    };

    SendCashMovement = async (valueSend) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { cashMovementModel, showRefMoveCashModal, newOrderModel, Action, idSessionSelected } = this.state
        let type = "";

        if (newOrderModel.TotalMoneyMovement === '' || Number(newOrderModel.TotalMoneyMovement) === 0) {
            showAlert({ type: "info", message: `Inserte un monto valido`, timeout: 10000 });
            return;
        }

        newOrderModel.ObjType = '';
        newOrderModel.TotalRestante = 0;
        const data = {
            destination: Action,
            cashMovementModel,
            idWorkShift: idSessionSelected,
            newOrderModel
        }
        enableSpinner(true);
        let createMovementCashResponse = await apiClient.createMovementCash(data);
        enableSpinner(false);

        if (createMovementCashResponse.status !== 1) {
            showAlert({ type: "error", message: createMovementCashResponse.message });
            return;
        }
        if (Action === 1) {
            await this.ShowCashInModal(false);
        } else {
            await this.ShowCashOutModal(false);
        }
        // Cerrar modal de retiros
        await this.ShowHideMoneyMovements(false);

        cashMovementModel.id = createMovementCashResponse.data.id || 0;
        cashMovementModel.docDate = createMovementCashResponse.data.docDate || ''
        cashMovementModel.docTime = createMovementCashResponse.data.docTime || ''
        cashMovementModel.cashAmount = createMovementCashResponse.data.cashSum || 0;
        // cashMovementModel.comment = createMovementCashResponse.data.comments || '';
        cashMovementModel.type = Action;
        await this.RefreshCashMovementModel(cashMovementModel);

        // Se comenta por que es la vista de counter de entradas y salidas
        // const option = Action ? Action : 3;
        // await this.GetMovementsCash(option)
        if (!showRefMoveCashModal) {
            await this.ShowRefMoveCashModal()
        }

        if (valueSend !== 1) {
            this.ShowTicketCashMovement(true);
        }
        type = cashMovementModel.type
        cashMovementModel.cashAmount = newOrderModel.MoneyMovements[0].Amount
        cashMovementModel.docDate = newOrderModel.MoneyMovements[0].DatePaycheck
        cashMovementModel.docTime = ""
        cashMovementModel.id = newOrderModel.MoneyMovements[0].PM_Code
        cashMovementModel.type = newOrderModel.MoneyMovements[0].PM_Name
        // Esto guarda el pdf de la entrada o salida de dinero
        if (valueSend !== 1) {
            this.PrintCashMovements((type === 1 ? "ChashIn" : "ChashOut"), "80", cashMovementModel);
        }
        if (valueSend === 1) {
            newOrderModel.MoneyMovements = [];
            newOrderModel.TotalMoneyMovement = 0.00;
            this.RefreshOrder(newOrderModel);
        }
        await this.setState({
            enableMoneyMovements: false,
        });
        $("#moneyMovementsModal").modal("hide");
    };

    GetMovementsCash = async (option) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { userSearch, finalDate, initialDate, typeUser } = this.state;

        await this.setState({
            optionSearchMovements: option,
        });

        // validar que se seleccione un chofer
        if (userSearch === '') {
            showAlert({ type: "error", message: `Aun no has seleccionado un usuario para a buscar.` });
            return
        }

        $("#withdrawalModal").modal("show");

        const data = {
            idWorkShift: userSearch || this.state.idSessionSelected,
            option,
            initialDate,
            finalDate,
            typeUser,
        }

        enableSpinner(true);
        const getMovementsCashResponse = await apiClient.getMovementsCash(data);
        enableSpinner(false);

        if (getMovementsCashResponse.status !== 1) {
            showAlert({ type: "info", message: getMovementsCashResponse.message });
            return;
        }

        if (getMovementsCashResponse.data.length === 0) {
            showAlert({ type: "info", message: "No hay Información registrada" });
        }

        await this.setState({
            Movements: getMovementsCashResponse.data || []
        });
    };

    ShowRefMoveCashModal = async () => {
        await this.setState({
            showRefMoveCashModal: !this.state.showRefMoveCashModal
        })
    };

    ShowTicketCashMovement = async (show) => {
        if (show) {
            $("#refMoveCashModal").modal("show");
        } else {
            $("#refMoveCashModal").modal("hide");
            await this.setState({ cashMovementModel: new CashMovement() })
        }
    };

    PrintCashMovements = async (type, paperSize, order) => {
        let user = JSON.parse(localStorage.getItem('Timbra1currentUser'));
        let items = [];
        let payments = [];
        let data = {
            Config: {
                TicketType: type,
                PaperSize: paperSize
            },
            Store: {
                Name: Datos_Empresa.Nombre + ' ' + Datos_Empresa.Sociedad,
                Address: user.Branch.Address || "",
                RFC: "",
                Phone: "",
                Logo: "",
                Footer: order.comment || order.comments || "",
                Consecutive: order.nextFolio || ""
            },
            BusinessPartner: {
                CardCode: "",
                CardName: "",
                RFC: "",
                Regime: "",
                Phone: "",
                AddressInvoice: "",
                AddressDelivery: ""
            },
            OrderSale: {
                DocNum: (order.id || order.folio || "").toString(),
                DocDate: moment(order.docDate).format('DD-MM-YYYY') + "  " + order.docTime.substring(11, 19) || "",
                DocOrigen: order.type || order.type || "",
                Seller: user.U_NAME || "",
                Cashier: user.USER_CODE || "",
                DocTotal: (CURRENCY + " " + Number(order.docTotal || (order.cashAmount ?? order.cashSum ?? 0)).toFixed(2)) || "",
                Subtotal: "",
                TaxTotal: "",
                TaxRate: "",
                DocCur: "",
                Items: items || "",
                Payments: payments || ""
            },
            CashCut: {
                Type: "",
                DocNum: "",
                DocDate: "",
                Cashier: "",
                DocTotal: "",
                DocCur: "",
                NumSales: "",
                NumReturns: "",
                NumCollects: "",
                TotalSale: "",
                TotalCash: "",
                TotalReturn: "",
                TotalCashIn: "",
                TotalCashOut: "",
                TotalCard: "",
                TotalTransfer: "",
                TotalCheck: "",
                TotalReturnAsPayment: "",
                TotalCredit: "",
                TotalCreditNote: "",
                TotalCollect: "",
                CashIns: [],
                CashOuts: [],
                Cards: [],
                Transfers: [],
                Checks: [],
                ReturnsAsPayment: [],
                Credits: [],
                CreditNotes: []
            }
        }
        data.Store.Logo = development == true ? "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"
            : Datos_Empresa.LogoBase64;

        let print = await apiClient.PrintDocuments(data);
    };

    openEntryMovement = async (type) => {
        const { Action, cashMovementModel, idSessionSelected } = this.state;

        if (Action === 2) {
            // Cargar sesión
            let responseApi = await apiClient.checkWorkSession();
            let idSession = '';
            if (responseApi.status === 1) {
                idSession = responseApi.data.idSession
                // await this.setState({ idSessionSelected: responseApi.data.idSession });
            }
            // Cargar sesión

            // Mandar comentario
            cashMovementModel.comment = 'Entrada de dinero de la sesión ' + idSessionSelected;
            await this.RefreshCashMovementModel(cashMovementModel)
            // No mostramos el modal por que se tiene que hacer la entrada al usuario de BRANCH
            await this.ChangeActionMoneyMovements(1, idSession);
            await this.SendCashMovement(1);
        }
    };

    SearchMovements = async () => {
        const { notificationReducer: { showAlert } } = this.props
        const { userSearch, optionSearchMovements } = this.state
        if (userSearch === '') {
            showAlert({ type: "error", message: `Aun no has seleccionado un usuario para a buscar.` });
            return
        }

        await this.GetMovementsCash(optionSearchMovements)
    };

    CleanMovements = async () => {
        await this.setState({
            Movements: [],
        })
    };

    validateBranchCashCut = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        let { warningModel, _user } = this.state;

        if (_user?.U_FMB_CounterRol !== "manager") return;

        enableSpinner(true);
        const responseApi = await apiClient.branchCashCutAction({ action: "validate" });
        enableSpinner(false);

        if (responseApi.status === SERVICE_RESPONSE.SUCCESS) {
            if (!responseApi.data.Status) {
                if (responseApi?.data?.TotalRows >= 2) {
                    return showAlert({ type: "warning", message: "La sucursal ya cuenta con dos sesiones activas, cierre alguna para continuar" });
                }

                warningModel.message = "Su sucursal no cuenta con una sesión activa, ¿Desea iniciar una nueva?";
                warningModel.acceptMsg = "Iniciar caja";
                warningModel.size = "modal-md";
                warningModel.accept = this.openBranchCashCut;
                await this.setState({ showWarningModal: true, warningModel });

                $("#warningModal").modal("show");
                $("#warningModal").on("hidden.bs.modal", async () => {
                    warningModel.accept = () => { };
                    await this.setState({
                        showWarningModal: false,
                        warningModel,
                    });
                });
            }
        } else {
            showAlert({ type: "error", message: responseApi.message || "Error al conectar con el servidor, intente más tarde" });
        }
    };

    openBranchCashCut = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;

        enableSpinner(true);
        const responseApi = await apiClient.branchCashCutAction({ action: "open" });
        enableSpinner(false);

        if (responseApi.status === SERVICE_RESPONSE.SUCCESS) {
            showAlert({ type: "success", message: responseApi.message || "Corte iniciado correctamente" });
            this.SearchLastBOEmployeesCashCuts();
        } else {
            showAlert({ type: "error", message: responseApi.message || "Error al conectar con el servidor, intente más tarde" });
        }
    };

    branchCashCut = async (IdSession) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;

        enableSpinner(true);
        const responseApi = await apiClient.branchCashCutAction({ action: "close", IdSession });
        enableSpinner(false);

        if (responseApi.status === SERVICE_RESPONSE.SUCCESS) {
            showAlert({ type: "success", message: responseApi.message || "Corte cerrado correctamente" });
            this.SearchLastBOEmployeesCashCuts();
        } else {
            showAlert({ type: "error", message: responseApi.message || "Error al conectar con el servidor, intente más tarde" });
        }
    }

    ValidateWorkSession = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;

        enableSpinner(true);
        const responseApi = await apiClient.checkWorkSession();
        enableSpinner(false);

        if (responseApi.status === SERVICE_RESPONSE.SUCCESS) {
            if (!responseApi.data.sessionStatus) {
                showAlert({ type: "warning", message: "Para este proceso es necesario tener una sesión en caja activa. Realiza esta acción desde el punto de venta para continuar", timeout: 10000 });
            } else {
                if (responseApi.data.NotCashCut === true) {
                    showAlert({ type: "warning", message: `${responseApi.message}. Realiza tu corte dentro del punto de venta para continuar`, timeout: 10000 });
                } else { return true; }
            }
        } else {
            showAlert({ type: "error", message: responseApi.message || "Error al conectar con el servidor, intente más tarde" });
        }

        return false;
    };

    AppCashCut = async (currentCashCut) => {
        if (await this.ValidateWorkSession()) {
            this.setState({ currentCashCut });
            if (currentCashCut?.typeUser === 'MVENTAS' && currentCashCut?.idSession) { // Revisar operaciones del usuario MVENTAS para saber si todo fue a crédito o saber si todo fue con QR
                const { enableSpinner, notificationReducer: { showAlert } } = this.props;
                enableSpinner(true);
                const responseApi = await apiClient.checkCreditOperations(currentCashCut);
                enableSpinner(false);
                if (responseApi?.status === SERVICE_RESPONSE.SUCCESS) {
                    if (responseApi?.data?.HasCreditOperations || responseApi?.data?.HasQROperations) { // Si todo fue crédito o todo fue QR permitir cerrar el corte de efectivo
                        this.openValidateCreditOperations();
                    }
                } else {
                    showAlert({ type: "error", message: responseApi.message || "Error al conectar con el servidor, intente más tarde" });
                }
            }
        }
    };

    CancelAppCashCut = async () => {
        this.setState({ currentCashCut: null });
    };

    updateStatusCashCut = async (idSession) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { cashCutsRecords } = this.state;
        const index = cashCutsRecords.findIndex((cashCut) => cashCut.idSession === idSession);

        enableSpinner(true);
        const apiResponse = await apiClient.updateCashCutInventory({ idSession });
        enableSpinner(false);

        if (apiResponse.status !== SERVICE_RESPONSE.SUCCESS) {
            showAlert({ type: "error", message: apiResponse.message || "Error al conectar con el servidor, intente más tarde" });
        }

        if (index !== -1) { cashCutsRecords[index].cashCutInventory = 'Y'; }
        this.setState({ cashCutsRecords })
    };

    ApprovePendingPaymentsRestriction = async (idSession) => {
        const { enableSpinner, notificationReducer: { showAlert }, } = this.props;

        try {
            enableSpinner(true);
            const responseApi = await apiClient.approvePendingPaymentsRestriction({ idSession, });

            showAlert({
                type: responseApi?.status === 1 ? 'success' : 'error',
                message: responseApi?.message || 'No fue posible aceptar la restricción',
            });

            if (responseApi?.status === 1) {
                this.SearchLastCashCuts();
            }
        } catch (error) {
            showAlert({ type: 'error', message: 'Error al aceptar la restricción', });
        } finally {
            enableSpinner(false);
        }
    };

    OpenBankMovement = (cashCut) => {
        let { warningModel } = this.state;
        warningModel.message = "Esta acción agrega un monto de efectivo ADICIONAL al corte del operador.\N¿Desea continuar?";
        warningModel.acceptMsg = "Continuar";
        warningModel.size = "modal-md";
        warningModel.accept = () => { this.ShowHideMoneyMovements(true); this.ChangeActionMoneyMovements(1, cashCut.idSession); };

        this.setState({ showWarningModal: true, warningModel }, () => {
            $("#warningModal").modal("show");
            $("#warningModal").on("hidden.bs.modal", async () => {
                warningModel.accept = () => { };
                await this.setState({
                    showWarningModal: false,
                    warningModel,
                });
            });
        });
    };

    render() {
        const { notificationReducer: { showAlert } } = this.props;
        const {
            TODAY,
            EmployeesCashCutReports,
            CommentCloseDoc,
            initialDate,
            finalDate,
            BranchOfficeInvoices,
            docsToPrint,
            typeDocPrint,
            _user,
            sendMailModel,
            BranchOfficeCreditNotes,
            users,
            userSearch,
            cashCutsRecords,
            cashCut,
            objCharge,
            totalCashCut,
            totalAmountSales,
            numSalesCashCut,
            extraPaymentsCashCut,
            headerCashCut,
            moneyOuts,
            moneyEntries,
            printhide,
            simulateResult,
            MonthDocument,
            typeUser,
            key,
            showAreYouAgreeModal,
            showValidateCutInventory,
            optionModal,
            showEditCutInventoryModal,
            newOrderModelCutInventory,
            enableMoneyMovements,
            PaymentSaleModel,
            Action,
            AvailablePayments,
            newOrderModel,
            addingMove,
            cashMovementModel,

            showRefMoveCashModal,
            Movements,
            showWarningModal,
            warningModel,
            currentCashCut,
            bankOptions = [],
            showValidateCreditOperations = false,
            idSessionSelected,
            authorizationCode
        } = this.state


        const canApprovePendingPayments =
            _user?.FMB_Role === 'admin1';
        const canSetCashCutPending = _user?.BranchPermission?.PendingCashCut
        let mailTools = {
            sendMailModel: sendMailModel,
            RefreshSendMailModel: this.RefreshSendMailModel,
            SendDocsByEmail: this.SendDocsByEmail
        }

        return (
            <div className="content">
                <NavBar props={this.props} logoCounter={true} _user={_user} />
                <TimeOut />
                <BreadCumb subitem1={'CIERRES Y CORTES'} url1={'#'} />
                <TwoStepsVerificationInventoryModal
                    IdModal={'TwoStepsInventory'}
                    ColorHeaderBG={'bg-warning text-dark'}
                    ChangeParam1={this.ChangeAuthenticationCode}
                    ExecuteParam1={this.ValidateAuthenticationCodeTwoSteps}
                    param1={key}
                    CloseActions={this.CloseActions}
                />
                <PendingCashCutModal
                    IdModal={'SetPendingCashCut'}
                    ColorHeaderBG={'bg-warning text-dark'}
                    ChangeParam1={this.ChangeAuthCodeCashCut}
                    ExecuteParam1={this.validateAutCashCutCode}
                    param1={authorizationCode}
                    CloseActions={this.ClosePndCashCutModal}
                    Title={'Establecer corte pendiente'}
                    headerText={'Código de autorizador'}
                    placeholder={'Escribe aquí tu código autorizador'}
                />

                {showValidateCutInventory &&
                    <AreYouAgreeModal
                        mensaje={`
                            Valida la información del corte \n
                            Antes de cerrar el corte de inventario, revisa que los conteos físicos coincidan con el sistema.\n
                            Si encuentras inconsistencias, aún puedes editarlas.\n
                            ¿Deseas revisar los datos antes de cerrar?
                            `}
                        accept={this.OpenEditModalCutInventory}
                        cancel={this.OpenAreYouAgreeModal}
                        option={optionModal}
                        currCashCut={cashCutsRecords.find(cut => cut.idSession === idSessionSelected)}
                        onChange={this.onChangeCashCut}
                    />
                }

                {showAreYouAgreeModal &&
                    <AreYouAgreeModal
                        mensaje={'¿Estás seguro que deseas cerrar el corte de inventario?'}
                        accept={this.ApproveCutInventory}
                        cancel={this.CloseShowAreYouAgreeModal}
                    />
                }

                {showValidateCreditOperations &&
                    <AreYouAgreeModal
                        mensaje={'¿Estás seguro que deseas cerrar el corte de efectivo?'}
                        accept={this.CloseCashCut}
                        cancel={this.CloseShowValidateCreditOperations}
                    />
                }

                {showEditCutInventoryModal &&
                    <EditCutInventoryModal
                        idWorkShift={this.state.idSessionSelected}
                        closeModal={() => this.setState({ showEditCutInventoryModal: false })}
                        newOrderModelCutInventory={newOrderModelCutInventory}
                        changeReference2={this.changeReference2}
                        changeCountQtyItem={this.changeCountQtyItem}
                        sendInventoryCountings={this.sendInventoryCountings}
                    />
                }

                {enableMoneyMovements &&
                    <MoneyMovements
                        PaymentSaleModel={PaymentSaleModel}
                        AvailablePayments={AvailablePayments}
                        newOrderModel={newOrderModel}
                        addingPay={addingMove}
                        AddPay={this.AddMove}
                        GetBankAccounts={'GetBankAccounts'}
                        CancelMoneyMovement={this.CancelMoneyMovement}
                        SendCashMovement={this.SendCashMovement}
                        Action={Action}
                        RefreshPaymentSaleModel={this.RefreshPaymentSaleModel}
                        showAlert={showAlert}
                        RefreshOrder={this.RefreshOrder}
                        BankAccounts={'BankAccounts'}
                        cashMovementModel={cashMovementModel}
                        ChangeComment={this.ChangeComment}
                    />
                }

                {showRefMoveCashModal &&
                    <RefMoveCashModal
                        {...this.props}
                        AddPay={this.AddMove}
                        RefreshCashMovementModel={this.RefreshCashMovementModel}
                        cashMovementModel={cashMovementModel}
                        newOrderModel={newOrderModel}
                        ShowRefMoveCashModal={() => this.ShowRefMoveCashModal}
                        Folio={''}
                        PrintCashMovements={this.PrintCashMovements}
                        _user={_user}
                        action={'inventory'}
                        valueOption={Action}
                        openEntryMovement={this.openEntryMovement}
                    />}

                <div style={{ marginLeft: "4rem" }}>
                    <div className="row ml-3 mr-3">
                        <h3 className="ml-3 mb-2 mt-3">Cierre y cortes</h3>
                    </div>
                    <div className='row m-1'>
                        <div className='col-12 col-md-6 mb-2 responsive-row'>

                        </div>
                        <div className='col-12 col-md-6 text-right responsive-row'>
                            <div className='row '>
                                <div className='col-12 col-md-6 mb-2 responsive-row'>
                                    <div className="input-group text-right">
                                        {/* <div className="input-group-prepend">
                                            <span className="input-group-text"><strong>Mes del corte: </strong></span>
                                        </div>
                                        <select
                                            name="select"
                                            className="form-control"
                                            style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                                            value={MonthDocument}
                                            onChange={(event) => this.ChangeDocDate(event.target.value)}>
                                            <option value="">Selecciona un mes</option>
                                            {months.map((month, index) => {
                                                return (
                                                    <option value={index}>{month}</option>
                                                )
                                            })}
                                        </select> */}
                                    </div>
                                </div>
                                <div className='col-12 col-md-6 mb-2 responsive-row'>
                                    <div className='row '>
                                    </div>
                                    {/* <button type="button" className="btn btn-danger ml-2"  data-toggle="modal" data-target="#closureModal" >
                                        <i className="fa fa-upload mr-2" aria-hidden="true" />
                                        Cierre de sucursal
                                    </button> */}
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className='m-3'>
                        <nav className='mt-4 ml-3' >
                            <div className="nav nav-tabs" id="nav-tab" role="tablist">
                                <a
                                    className={"nav-item nav-link font-weight-bold text-secondary active"}
                                    id="nav-profile-tab-ListChashCutToMake"
                                    data-toggle="tab"
                                    href="#dataListChashCutToMake"
                                    role="tab"
                                    aria-controls="dataListChashCutToMake"
                                >
                                    Cortes Pendientes
                                </a>
                                <a
                                    className={"nav-item nav-link font-weight-bold text-secondary "}
                                    id="nav-home-tab-Closures"
                                    data-toggle="tab"
                                    href="#dataClosures"
                                    role="tab"
                                    aria-controls="dataClosures"
                                    onClick={() => this.SearchBranchOfficeInvoices(1)}
                                >
                                    Fact. consolidado
                                </a>
                                <a
                                    className={"nav-item nav-link font-weight-bold text-secondary "}
                                    id="nav-home-tab-InvoiceMostrador"
                                    data-toggle="tab"
                                    href="#dataInvoiceMostrador"
                                    role="tab"
                                    aria-controls="dataInvoiceMostrador"
                                    onClick={() => this.SearchBranchOfficeInvoices(2)}
                                >
                                    Fact. mostrador
                                </a>
                                <a
                                    className={"nav-item nav-link font-weight-bold text-secondary"}
                                    id="nav-home-tab-CreditNotes"
                                    data-toggle="tab"
                                    href="#dataCreditNotes"
                                    role="tab"
                                    aria-controls="CreditNotes"
                                    onClick={() => this.SearchBranchOfficeCreditNotes(1)}
                                >
                                    NC Consolidado
                                </a>
                                <a
                                    className={"nav-item nav-link font-weight-bold text-secondary"}
                                    id="nav-home-tab-CreditMostrador"
                                    data-toggle="tab"
                                    href="#dataCreditMostrador"
                                    role="tab"
                                    aria-controls="dataCreditMostrador"
                                    onClick={() => this.SearchBranchOfficeCreditNotes(2)}
                                >
                                    NC Mostrador
                                </a>
                                <a
                                    className={"nav-item nav-link font-weight-bold text-secondary"}
                                    id="nav-home-tab-employee-CashCuts"
                                    data-toggle="tab"
                                    href="#employee-CashCuts"
                                    role="tab"
                                    aria-controls="employee-CashCuts"
                                // onClick={() => this.SearchBranchOfficeCreditNotes(2)}
                                >
                                    Cortes empleado
                                </a>
                                <a
                                    className={"nav-item nav-link font-weight-bold text-secondary"}
                                    id="nav-home-tab-sucursal-CashCuts"
                                    data-toggle="tab"
                                    href="#sucursal-Closures"
                                    role="tab"
                                    aria-controls="sucursal-Closures"
                                    onClick={this.validateBranchCashCut}
                                >
                                    Cortes de sucursal
                                </a>
                                <a
                                    className={"nav-item nav-link font-weight-bold text-secondary"}
                                    id="nav-home-tab-Apps-CashCuts"
                                    data-toggle="tab"
                                    href="#Apps-CashCuts"
                                    role="tab"
                                    aria-controls="Apps-CashCuts"
                                    onClick={() => { this.ChangeTypeUser('2'); this.CleanMovements(); }}
                                >
                                    Cortes monetarios APPS
                                </a>
                            </div>
                        </nav>
                        <div className="tab-content pl-3" style={{ textAlign: 'left' }}>

                            {/* Cortes Pendientes */}
                            <div
                                className="w-100 tab-pane active"
                                id="dataListChashCutToMake"
                                role="tabpanel"
                                aria-labelledby="nav-profile-tab-List"
                                style={{ paddingTop: 5, border: "1px solid #00000020", borderTop: "none", borderRadius: "0.25rem" }}>

                                <div className="row m-1">
                                    <div className="col-xl-12 mb-4 mb-xl-0 responsive-row">
                                        <div className="row p-1">
                                            <div className="col-12 col-md-5 mb-2 responsive-row">
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text fw-bold">
                                                            <span className="d-none d-xl-inline"><strong>Fecha actual:</strong></span>
                                                            <span className="d-inline d-xl-none"><strong>F.Actual:</strong></span>
                                                        </span>
                                                    </div>
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        disabled={true}
                                                        value={TODAY}
                                                        max='9999-12-31'
                                                    />
                                                </div>
                                            </div>
                                            {/* <div className='col-md-9 text-right'>
                                                <button
                                                    type="button"
                                                    className="btn btn-primary ml-2"
                                                    style={{ backgroundColor: "rgb(233, 236, 239)", color: "rgb(73, 80, 87)", border: "1px solid rgb(206, 212, 218)" }}
                                                    onClick={() => this.PrintEmployeesBOCut(false)} >
                                                    <i className="fa fa-print mr-2" aria-hidden="true" />
                                                    Cortes de sucursal
                                                </button>
                                            </div> */}


                                        </div>
                                        <div className='card scrollTableClosures mb-3' >
                                            <table className="table table-striped table-hover" id="inData" >
                                                <thead className='sticky-headerPOS' style={{ backgroundColor: "white" }}>
                                                    <tr>
                                                        <th className="text-center">Código</th>
                                                        <th className="text-left">Usuario</th>
                                                        <th className="text-center">Fecha de inicio</th>
                                                        <th className="text-center">Hora de inicio</th>
                                                        {/* <th className="text-right">Venta actual</th> */}
                                                        <th className="text-center">Estatus</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {EmployeesCashCutReports && EmployeesCashCutReports.length > 0 &&
                                                        EmployeesCashCutReports.map((employeeReport) => {
                                                            return (
                                                                <tr >
                                                                    <td className="text-center">{employeeReport.USERID ?? ''}</td>
                                                                    <td className="text-left">{employeeReport.U_NAME}</td>
                                                                    <td className="text-center">{moment(employeeReport.docDate).format('YYYY-MM-DD')}</td>
                                                                    <td className="text-center">{employeeReport.initSession}</td>
                                                                    {/* <td className="text-right">$150,000.00</td> */}
                                                                    {/* <td className="text-center"></td> */}
                                                                    <td className="text-center">
                                                                        <i className={`${employeeReport.sessionStatus === 'O' ? 'fa fa-exclamation-triangle' : 'fa fa fa-check'} mr-2`} aria-hidden="true" style={{ color: `${employeeReport.sessionStatus === 'O' ? "#eabf28" : "#28a745"}` }}></i>
                                                                        {employeeReport.sessionStatus === 'O' ? 'Corte pendiente' : 'Corte realizado'}
                                                                    </td>
                                                                </tr>
                                                            )

                                                        })
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            {/* Factura consolidador */}
                            <div
                                className="w-100 table-scroll tab-pane "
                                id="dataClosures"
                                role="tabpanel"
                                aria-labelledby="nav-home-tab-Depositos"
                                style={{ paddingTop: 5, border: "1px solid #00000020", borderTop: "none", borderRadius: "0.25rem" }}>

                                <div className="row m-1">
                                    <div className="col-xl-12 mb-4 mb-xl-0 responsive-row">
                                        <div className="row p-1">
                                            <div className="col-12 col-md-4 mb-2">
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text"><strong>Desde: </strong></span>
                                                    </div>
                                                    <input
                                                        type="date"
                                                        value={initialDate}
                                                        onChange={(event) => this.ChangeInitialDate(event)}
                                                        onBlur={() => this.ValidateInitialDate()}
                                                        onKeyPress={(ev) => {
                                                            if (ev.key === 'Enter') {
                                                                this.SearchBranchOfficeInvoices(1);

                                                            }
                                                        }}
                                                        max='9999-12-31'
                                                        className="form-control"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-4 mb-2">
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text"><strong>Hasta: </strong></span>
                                                    </div>
                                                    <input
                                                        type="date"
                                                        value={finalDate}
                                                        onChange={(event) => this.ChangeFinalDate(event)}
                                                        onBlur={() => this.ValidateFinalDate()}
                                                        onKeyPress={(ev) => {
                                                            if (ev.key === 'Enter') {
                                                                this.SearchBranchOfficeInvoices(1);

                                                            }
                                                        }}
                                                        max='9999-12-31'
                                                        className="form-control"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-4 text-right mb-2">
                                                <div className='input-group-append '>
                                                    <button type="button" className="btn btn-primary ml-0" onClick={() => this.SearchBranchOfficeInvoices(1)} style={{ backgroundColor: "rgb(233, 236, 239)", color: "rgb(73, 80, 87)", border: "1px solid rgb(206, 212, 218)" }}>
                                                        <i className="fa fa-search mr-2" aria-hidden="true" />
                                                        Buscar
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='card scrollTableClosures' >
                                            <table className="table table-striped table-hover" id="inData" >
                                                <thead className='sticky-headerPOS' style={{ backgroundColor: "white" }}>
                                                    <tr>
                                                        <th className="text-center">Fecha y hora</th>
                                                        <th className="text-center">Nombre</th>
                                                        <th className="text-center">Rol</th>
                                                        <th className="text-center">Venta</th>
                                                        <th className="text-center">Folio</th>
                                                        <th className="text-center"></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {BranchOfficeInvoices && BranchOfficeInvoices.length > 0 &&
                                                        BranchOfficeInvoices.map((invoice) => {
                                                            return (
                                                                <tr >
                                                                    <td className="text-center">{moment(invoice.docDate).utc().format('YYYY-MM-DD')}</td>
                                                                    <td className="text-center">{invoice.U_NAME ?? ''}</td>
                                                                    <td className="text-center">{invoice.U_FMB_role ?? ''}</td>
                                                                    <td className="text-center">{CURRENCY + ' ' + FORMAT_NUMBER.new(invoice.docTotal)}</td>
                                                                    <td className="text-center">{invoice.folio ?? ''}</td>
                                                                    <td className="text-center sticky-column">
                                                                        <button className="btn btn-active" onClick={() => this.ShowDetailInvoiceBO(invoice.folio)}
                                                                            style={{ backgroundColor: "#e9ecef", color: "#495057", border: "1px solid #ced4da", align: "right" }}>
                                                                            <i className="fa fa-file-text-o mr-2"></i>
                                                                            Ver documentos
                                                                        </button>
                                                                    </td>
                                                                    {/* <td className="text-center sticky-column">
                                                                        <button className="btn btn-active" onClick={() => this.ShowDetailInvoiceBO(invoice.folio)}
                                                                            style={{ backgroundColor: "#e9ecef", color: "#495057", border: "1px solid #ced4da", align: "right" }}>
                                                                            <i className="fa fa-file-text-o mr-2"></i>
                                                                            Pago
                                                                        </button>
                                                                    </td> */}
                                                                </tr>
                                                            )

                                                        })
                                                    }

                                                    <tr className='noSearch hide'>
                                                        <td colSpan="7"></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            {/* Factura mostrador */}
                            <div
                                className="w-100 table-scroll tab-pane "
                                id="dataInvoiceMostrador"
                                role="tabpanel"
                                aria-labelledby="nav-home-tab-Depositos"
                                style={{ paddingTop: 5, border: "1px solid #00000020", borderTop: "none", borderRadius: "0.25rem" }}>

                                <div className="row m-1">
                                    <div className="col-xl-12 mb-4 mb-xl-0 responsive-row">
                                        <div className="row p-1">
                                            <div className="col-12 col-md-4 mb-2">
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text"><strong>Desde: </strong></span>
                                                    </div>
                                                    <input
                                                        type="date"
                                                        value={initialDate}
                                                        onChange={(event) => this.ChangeInitialDate(event)}
                                                        onBlur={() => this.ValidateInitialDate()}
                                                        onKeyPress={(ev) => {
                                                            if (ev.key === 'Enter') {
                                                                this.SearchBranchOfficeInvoices(2);

                                                            }
                                                        }}
                                                        max='9999-12-31'
                                                        className="form-control"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-4 mb-2">
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text"><strong>Hasta: </strong></span>
                                                    </div>
                                                    <input
                                                        type="date"
                                                        value={finalDate}
                                                        onChange={(event) => this.ChangeFinalDate(event)}
                                                        onBlur={() => this.ValidateFinalDate()}
                                                        onKeyPress={(ev) => {
                                                            if (ev.key === 'Enter') {
                                                                this.SearchBranchOfficeInvoices(2);

                                                            }
                                                        }}
                                                        max='9999-12-31'
                                                        className="form-control"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-4 text-right mb-2">
                                                <div className='input-group-append '>
                                                    <button type="button" className="btn btn-primary ml-0" onClick={() => this.SearchBranchOfficeInvoices(2)} style={{ backgroundColor: "rgb(233, 236, 239)", color: "rgb(73, 80, 87)", border: "1px solid rgb(206, 212, 218)" }}>
                                                        <i className="fa fa-search mr-2" aria-hidden="true" />
                                                        Buscar
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='card scrollTableClosures' >
                                            <table className="table table-striped table-hover" id="inData" >
                                                <thead className='sticky-headerPOS' style={{ backgroundColor: "white" }}>
                                                    <tr>
                                                        <th className="text-center">Fecha y hora</th>
                                                        <th className="text-center">Nombre</th>

                                                        <th className="text-center">Rol</th>
                                                        <th className="text-center">Venta</th>
                                                        <th className="text-center">Folio</th>
                                                        <th className="text-center"></th>

                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {BranchOfficeInvoices && BranchOfficeInvoices.length > 0 &&

                                                        BranchOfficeInvoices.map((invoice) => {
                                                            return (
                                                                <tr >
                                                                    <td className="text-center">{moment(invoice.docDate).format('YYYY-MM-DD')}</td>
                                                                    <td className="text-center">{invoice.U_NAME ?? ''}</td>


                                                                    <td className="text-center">{invoice.U_FMB_role ?? ''}</td>
                                                                    <td className="text-center">{CURRENCY + ' ' + FORMAT_NUMBER.new(invoice.docTotal)}</td>
                                                                    <td className="text-center">{invoice.folio ?? ''}</td>

                                                                    <td className="text-center sticky-column">
                                                                        <button className="btn btn-active" onClick={() => this.ShowDetailInvoiceBO(invoice.folio)}
                                                                            style={{ backgroundColor: "#e9ecef", color: "#495057", border: "1px solid #ced4da", align: "right" }}>
                                                                            <i className="fa fa-file-text-o mr-2"></i>
                                                                            Ver documentos
                                                                        </button>
                                                                    </td>

                                                                </tr>
                                                            )

                                                        })
                                                    }

                                                    <tr className='noSearch hide'>
                                                        <td colSpan="7"></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            {/* Notas de crédito consolidado */}
                            <div
                                className="w-100 table-scroll tab-pane "
                                id="dataCreditNotes"
                                role="tabpanel"
                                aria-labelledby="nav-home-tab-CreditNotes"
                                style={{ paddingTop: 5, border: "1px solid #00000020", borderTop: "none", borderRadius: "0.25rem" }}>

                                <div className="row m-1">
                                    <div className="col-xl-12 mb-4 mb-xl-0 responsive-row">
                                        <div className="row p-1">
                                            <div className="col-12 col-md-4 mb-2">
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text"><strong>Desde: </strong></span>
                                                    </div>
                                                    <input
                                                        type="date"
                                                        value={initialDate}
                                                        onChange={(event) => this.ChangeInitialDate(event)}
                                                        onBlur={() => this.ValidateInitialDate()}
                                                        onKeyPress={(ev) => {
                                                            if (ev.key === 'Enter') {
                                                                this.SearchBranchOfficeCreditNotes(1);
                                                            }
                                                        }}
                                                        max='9999-12-31'
                                                        className="form-control"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-4 mb-2">
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text"><strong>Hasta: </strong></span>
                                                    </div>
                                                    <input
                                                        type="date"
                                                        value={finalDate}
                                                        onChange={(event) => this.ChangeFinalDate(event)}
                                                        onBlur={() => this.ValidateFinalDate()}
                                                        onKeyPress={(ev) => {
                                                            if (ev.key === 'Enter') {
                                                                this.SearchBranchOfficeCreditNotes(1)
                                                            }
                                                        }}
                                                        max='9999-12-31'
                                                        className="form-control"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-4 text-right mb-2">
                                                <div className='input-group-append '>
                                                    <button type="button" className="btn btn-primary ml-0" onClick={() => this.SearchBranchOfficeCreditNotes(1)} style={{ backgroundColor: "rgb(233, 236, 239)", color: "rgb(73, 80, 87)", border: "1px solid rgb(206, 212, 218)" }}>
                                                        <i className="fa fa-search mr-2" aria-hidden="true" />
                                                        Buscar
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='card scrollTableClosures' >
                                            <table className="table table-striped table-hover" id="inData" >
                                                <thead className='sticky-headerPOS' style={{ backgroundColor: "white" }}>
                                                    <tr>
                                                        <th className="text-center">Fecha y hora</th>
                                                        <th className="text-center">Nombre</th>
                                                        <th className="text-center">Rol</th>
                                                        <th className="text-center">Venta</th>
                                                        <th className="text-center">Folio</th>
                                                        <th className="text-center"></th>

                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {BranchOfficeCreditNotes && BranchOfficeCreditNotes.length > 0 &&
                                                        BranchOfficeCreditNotes.map((creditNote) => {
                                                            return (
                                                                <tr >
                                                                    <td className="text-center">{moment(creditNote.docDate).format('YYYY-MM-DD')}</td>
                                                                    <td className="text-center">{creditNote.U_NAME ?? ''}</td>
                                                                    <td className="text-center">{creditNote.U_FMB_role ?? ''}</td>
                                                                    <td className="text-center">{CURRENCY + ' ' + FORMAT_NUMBER.new(creditNote.docTotal)}</td>
                                                                    <td className="text-center">{creditNote.folio ?? ''}</td>
                                                                    <td className="text-center sticky-column">
                                                                        <button className="btn btn-active" onClick={() => this.ShowDetailCreditNoteBO(creditNote.folio)}
                                                                            style={{ backgroundColor: "#e9ecef", color: "#495057", border: "1px solid #ced4da", align: "right" }}>
                                                                            <i className="fa fa-file-text-o mr-2"></i>
                                                                            Ver documentos
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        })
                                                    }
                                                    <tr className='noSearch hide'>
                                                        <td colSpan="7"></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            {/* Notas de crédito mostrador */}
                            <div
                                className="w-100 table-scroll tab-pane "
                                id="dataCreditMostrador"
                                role="tabpanel"
                                aria-labelledby="nav-home-tab-dataCreditMostrador"
                                style={{ paddingTop: 5, border: "1px solid #00000020", borderTop: "none", borderRadius: "0.25rem" }}>

                                <div className="row m-1">
                                    <div className="col-xl-12 mb-4 mb-xl-0 responsive-row">
                                        <div className="row p-1">
                                            <div className="col-12 col-md-4 mb-2">
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text"><strong>Desde: </strong></span>
                                                    </div>
                                                    <input
                                                        type="date"
                                                        value={initialDate}
                                                        onChange={(event) => this.ChangeInitialDate(event)}
                                                        onBlur={() => this.ValidateInitialDate()}
                                                        onKeyPress={(ev) => {
                                                            if (ev.key === 'Enter') {
                                                                this.SearchBranchOfficeCreditNotes(2);
                                                            }
                                                        }}
                                                        max='9999-12-31'
                                                        className="form-control"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-4 mb-2">
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text"><strong>Hasta: </strong></span>
                                                    </div>
                                                    <input
                                                        type="date"
                                                        value={finalDate}
                                                        onChange={(event) => this.ChangeFinalDate(event)}
                                                        onBlur={() => this.ValidateFinalDate()}
                                                        onKeyPress={(ev) => {
                                                            if (ev.key === 'Enter') {
                                                                this.SearchBranchOfficeCreditNotes(2)
                                                            }
                                                        }}
                                                        max='9999-12-31'
                                                        className="form-control"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-4 text-right mb-2">
                                                <div className='input-group-append'>
                                                    <button type="button" className="btn btn-primary ml-0" onClick={() => this.SearchBranchOfficeCreditNotes(2)} style={{ backgroundColor: "rgb(233, 236, 239)", color: "rgb(73, 80, 87)", border: "1px solid rgb(206, 212, 218)" }}>
                                                        <i className="fa fa-search mr-2" aria-hidden="true" />
                                                        Buscar
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='card scrollTableClosures' >
                                            <table className="table table-striped table-hover" id="inData" >
                                                <thead className='sticky-headerPOS' style={{ backgroundColor: "white" }}>
                                                    <tr>
                                                        <th className="text-center">Fecha y hora</th>
                                                        <th className="text-center">Nombre</th>
                                                        <th className="text-center">Rol</th>
                                                        <th className="text-center">Venta</th>
                                                        <th className="text-center">Folio</th>
                                                        <th className="text-center"></th>

                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {BranchOfficeCreditNotes && BranchOfficeCreditNotes.length > 0 &&
                                                        BranchOfficeCreditNotes.map((creditNote) => {
                                                            return (
                                                                <tr >
                                                                    <td className="text-center">{moment(creditNote.docDate).format('YYYY-MM-DD')}</td>
                                                                    <td className="text-center">{creditNote.U_NAME ?? ''}</td>
                                                                    <td className="text-center">{creditNote.U_FMB_role ?? ''}</td>
                                                                    <td className="text-center">{CURRENCY + ' ' + FORMAT_NUMBER.new(creditNote.docTotal)}</td>
                                                                    <td className="text-center">{creditNote.folio ?? ''}</td>
                                                                    <td className="text-center sticky-column">
                                                                        <button className="btn btn-active" onClick={() => this.ShowDetailCreditNoteBO(creditNote.folio)}
                                                                            style={{ backgroundColor: "#e9ecef", color: "#495057", border: "1px solid #ced4da", align: "right" }}>
                                                                            <i className="fa fa-file-text-o mr-2"></i>
                                                                            Ver documentos
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        })
                                                    }
                                                    <tr className='noSearch hide'>
                                                        <td colSpan="7"></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            {/* Cortes de  cajero*/}
                            <div
                                className="w-100 table-scroll tab-pane "
                                id="employee-CashCuts"
                                role="tabpanel"
                                aria-labelledby="nav-home-tab-employee-CashCuts"
                                style={{ paddingTop: 5, border: "1px solid #00000020", borderTop: "none", borderRadius: "0.25rem" }}>
                                <div className="row m-1">
                                    <div className="col-xl-12 mb-4 mb-xl-0">
                                        <div className="row p-1">
                                            <div className="col-12 col-md-4 col-lg-3 col-xl-2 mb-2">
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text"><strong>Tipo: </strong></span>
                                                    </div>
                                                    <select
                                                        name="select"
                                                        className="form-control"
                                                        style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                                                        value={typeUser || ""}
                                                        onChange={(event) => this.ChangeTypeUser(event.target.value)}
                                                    >
                                                        <option value="">Seleccionar</option>

                                                        <option key={'1'} value={'1'}>Counter</option>
                                                        <option key={'2'} value={'2'}>MVentas</option>
                                                        {/* <option key={'3'} value={'3'}>Otro</option> */}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-4 col-lg-4 col-xl-4 mb-2">
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text"><strong>Usuario: </strong></span>
                                                    </div>
                                                    <select
                                                        name="select"
                                                        className="form-control"
                                                        style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                                                        value={userSearch || ""}
                                                        onChange={(event) => this.ChangeUserToSearch(event.target.value)}
                                                    >
                                                        <option value="">Seleccionar</option>
                                                        {!!users && users.map((user, index) => {
                                                            return (
                                                                <option key={index} value={user.USERID}>{user.U_NAME} - {user.E_Mail} </option>
                                                            )
                                                        })}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-4 col-lg-2 col-xl-2 mb-2">
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text"><strong>Desde: </strong></span>
                                                    </div>
                                                    <input
                                                        type="date"
                                                        value={initialDate}
                                                        onChange={(event) => this.ChangeInitialDate(event)}
                                                        onBlur={() => this.ValidateInitialDate()}
                                                        onKeyPress={(ev) => {
                                                            if (ev.key === 'Enter') {
                                                                this.SearchLastCashCuts();
                                                            }
                                                        }}
                                                        max='9999-12-31'
                                                        className="form-control"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-4 col-lg-2 col-xl-2 mb-2">
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text"><strong>Hasta: </strong></span>
                                                    </div>
                                                    <input
                                                        type="date"
                                                        value={finalDate}
                                                        onChange={(event) => this.ChangeFinalDate(event)}
                                                        onBlur={() => this.ValidateFinalDate()}
                                                        onKeyPress={(ev) => {
                                                            if (ev.key === 'Enter') {
                                                                this.SearchLastCashCuts();
                                                            }
                                                        }}
                                                        max='9999-12-31'
                                                        className="form-control"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-4 col-lg-1 col-xl-2 mb-2 ml-auto text-right">
                                                <div className='input-group-append '>
                                                    <button type="button" className="btn btn-primary ml-0" onClick={() => this.SearchLastCashCuts()} style={{ backgroundColor: "rgb(233, 236, 239)", color: "rgb(73, 80, 87)", border: "1px solid rgb(206, 212, 218)", whiteSpace: "nowrap" }}>
                                                        <i className="fa fa-search mr-2" aria-hidden="true" />
                                                        Buscar
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='card scrollTableClosures' >
                                            <table className="table table-striped table-hover" id="inData" >
                                                <thead className='sticky-headerPOS' style={{ backgroundColor: "white" }}>
                                                    <tr>
                                                        <th className="text-center">Folio</th>
                                                        <th className="text-center">Fecha</th>
                                                        <th className="text-center">Nombre</th>
                                                        <th className="text-center">Rol</th>
                                                        <th className="text-center">Email</th>
                                                        <th className="text-center">Estatus</th>
                                                        <th className="text-center"></th>
                                                        <th className="text-center"></th>
                                                        {typeUser === '2' && <th className="text-center"></th>}
                                                        {_user?.U_FMB_CounterRol === "manager" && <th className="text-center"></th>}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {cashCutsRecords && cashCutsRecords.length > 0 &&
                                                        cashCutsRecords.map((cashCut) => {
                                                            return (
                                                                <tr >
                                                                    <td className="text-center">{cashCut.idSession + "-" + moment(cashCut.docDate).format('YYYY-MM-DD').replace(/-/g, "")}</td>
                                                                    <td className="text-center">{moment(cashCut.docDate).format('YYYY-MM-DD')}</td>
                                                                    <td className="text-center">{cashCut.U_NAME ?? ''}</td>
                                                                    <td className="text-center">{cashCut.typeUser ?? ''}</td>
                                                                    <td className="text-center">{cashCut.E_Mail ?? ''}</td>
                                                                    <td className="text-center">{cashCut.sessionStatus === 'C' ? 'Cerrado' : 'Abierto'}</td>
                                                                    <td className="text-center sticky-column">
                                                                        <button className="btn btn-active" onClick={() => this.ShowCashCutModal(cashCut.idSession, cashCut, false)}
                                                                            disabled={cashCut.sessionStatus === 'C' ? false : true}
                                                                            style={{ backgroundColor: "#e9ecef", color: "#495057", border: "1px solid #ced4da", align: "right" }}>
                                                                            <i className="fa fa-print mr-2"></i>
                                                                            Ver Corte
                                                                        </button>
                                                                    </td>
                                                                    <td className="text-center sticky-column">
                                                                        <button className="btn btn-active" onClick={() => this.ShowDetailCutUser(cashCut.idSession, cashCut.docDate)}
                                                                            // disabled={cashCut.sessionStatus === 'C' ? false : true}
                                                                            style={{ backgroundColor: "#e9ecef", color: "#495057", border: "1px solid #ced4da", align: "right" }}>
                                                                            <i className="fa fa-file-text-o mr-2"></i>
                                                                            Ver detalles
                                                                        </button>
                                                                    </td>
                                                                    {typeUser === '2' && cashCut.closeInventory === 'N' ?
                                                                        (
                                                                            <td className="text-center sticky-column">
                                                                                <button className="btn btn-active" onClick={() => this.ShowDetailCutInventory(cashCut.idSession, cashCut.docDate)}
                                                                                    disabled={cashCut.twoFACodeUsed === 'Y' ? false : true}
                                                                                    style={{ backgroundColor: "#e9ecef", color: "#495057", border: "1px solid #ced4da", align: "right" }}>
                                                                                    <i className="fa fa-file-text-o mr-2"></i>
                                                                                    Corte de inventario
                                                                                </button>
                                                                            </td>
                                                                        )
                                                                        : (
                                                                            typeUser === '2' && (
                                                                                <td className="text-center sticky-column">
                                                                                    <label className="btn float-left" onClick={() => this.DownloadFiles('PDF', cashCut.idSession)}>
                                                                                        <i className="fa fa-file-text-o"></i> Descargar PDF
                                                                                    </label>
                                                                                </td>
                                                                            )
                                                                        )
                                                                    }
                                                                    {_user?.U_FMB_CounterRol === "manager" && (
                                                                        <td className="text-center sticky-column">
                                                                            {!cashCut.authorizedSession &&
                                                                                (<>
                                                                                    {(typeUser === '2' && cashCut.twoFACodeUsed !== 'Y') &&
                                                                                        <button className="btn btn-outline-success ml-2" onClick={async () => { if (await this.ValidateWorkSession()) { this.ShowDynamicModal('TwoStepsInventory', cashCut.idSession); } }}> <i className="fas fa-check-circle mr-2" /> Validar token </button>
                                                                                    }
                                                                                    {(typeUser === '2' && cashCut.twoFACodeUsed === 'Y' && cashCut.closeInventory === 'N') &&
                                                                                        <button className="btn btn-outline-success ml-2" onClick={() => this.OpenAreYouAgreeModalCutInventory(cashCut.idSession)}> <i className="fas fa-check-circle mr-2" /> Cerrar corte de inventario </button>
                                                                                    }
                                                                                    {(typeUser === '2' && cashCut.twoFACodeUsed === 'Y' && cashCut.closeInventory === 'Y' && (cashCut.cashCutInventory || "N") === 'N') &&
                                                                                        <button className="btn btn-outline-success ml-2" onClick={() => this.AppCashCut(cashCut)}> <i className="fas fa-money-bill-wave mr-2" /> Cerrar corte de efectivo </button>
                                                                                    }
                                                                                    {((typeUser === '1' || (typeUser === '2' && cashCut.closeInventory === 'Y' && cashCut.cashCutInventory === 'Y')) && (cashCut.sessionStatus === 'C' || cashCut.cashCutInventory === 'Y') &&
                                                                                        (cashCut.hasPendingPayments !== 'Y' || cashCut.pendingPaymentsApproved === 'Y') && (cashCut.hasPendingPayments !== 'Y' || Number(_user?.USERID) !== Number(cashCut.idUser))) && (
                                                                                            <button className="btn btn-outline-success ml-2" onClick={() => this.ApproveCut(cashCut.idSession)}><i className="fas fa-clipboard-check mr-2" /> Autorizar Corte</button>
                                                                                        )}
                                                                                    {cashCut.sessionStatus === 'C' && cashCut.hasPendingPayments === 'Y' && cashCut.pendingPaymentsApproved !== 'Y' && canApprovePendingPayments && Number(_user?.USERID) !== Number(cashCut.idUser) && (
                                                                                        <button className="btn btn-outline-warning ml-2" onClick={() => this.ApprovePendingPaymentsRestriction(cashCut.idSession)}><i className="fa fa-exclamation-triangle mr-2" /> Autorizar cierre pendiente</button>
                                                                                    )}
                                                                                    {/* {(typeUser === '2' && (cashCut.cashCutInventory || "N") === 'N') &&
                                                                                    <button className="btn btn-outline-success ml-2" onClick={() => this.OpenBankMovement(cashCut)}> Entrada de dinero </button>
                                                                                } */}
                                                                                </>)}
                                                                            {canSetCashCutPending &&//USUARIO CON PERMISO
                                                                                (cashCut?.StatusCashCut != 'Pnd') &&//SI AUN NO ESTA PENDIENTE
                                                                                (typeUser === '1' || (typeUser === '2' && cashCut.twoFACodeUsed === 'Y')) &&//TIPO COUNTER O TIPO APP CON TOKEN AUTORIZADO, SI NO, NO SE PUEDE PONER PENDIENTE
                                                                                <button
                                                                                    className="btn btn-outline-warning ml-2"
                                                                                    // onClick={() => this.ShowDynamicModal('SetPendingCashCut', cashCut.idSession)}
                                                                                    onClick={() => this.validateAutCashCutCode(cashCut.idSession)}
                                                                                >
                                                                                    <i className="fas fa-shield-alt mr-2" /> Establecer corte pendiente
                                                                                </button>
                                                                            }

                                                                        </td>
                                                                    )}
                                                                </tr>
                                                            )
                                                        })
                                                    }
                                                    <tr className='noSearch hide'>
                                                        <td colSpan="7"></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                    </div>
                                </div>
                            </div>


                            {/* Cortes de sucursal*/}
                            <div
                                className="w-100 table-scroll tab-pane "
                                id="sucursal-Closures"
                                role="tabpanel"
                                aria-labelledby="nav-home-tab-sucursal-CashCuts"
                                style={{ paddingTop: 5, border: "1px solid #00000020", borderTop: "none", borderRadius: "0.25rem" }}>
                                <div className="row m-1">
                                    <div className="col-xl-12 mb-4 mb-xl-0 responsive-row">
                                        <div className="row p-1">
                                            <div className="col-12 col-md-4 mb-2">
                                                <button type="button" className="btn btn-primary ml-0" onClick={() => this.PrintEmployeesBOCut(true)} style={{ backgroundColor: "white", color: "white", border: "1px solid white" }}>
                                                    <i className="fa fa-search mr-2" aria-hidden="true" style={{ color: "white" }} />
                                                </button>
                                            </div>
                                            <div className="col-12 col-md-4 mb-2">
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text"><strong>Desde: </strong></span>
                                                    </div>
                                                    <input
                                                        type="date"
                                                        value={initialDate}
                                                        onChange={(event) => this.ChangeInitialDate(event)}
                                                        onBlur={() => this.ValidateInitialDate()}
                                                        onKeyPress={(ev) => {
                                                            if (ev.key === 'Enter') {
                                                                // this.SearchLastCashCuts();
                                                            }
                                                        }}
                                                        max='9999-12-31'
                                                        className="form-control"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-4 mb-2">
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text"><strong>Hasta: </strong></span>
                                                    </div>
                                                    <input
                                                        type="date"
                                                        value={finalDate}
                                                        onChange={(event) => this.ChangeFinalDate(event)}
                                                        onBlur={() => this.ValidateFinalDate()}
                                                        onKeyPress={(ev) => {
                                                            if (ev.key === 'Enter') {
                                                                // this.SearchLastCashCuts();
                                                            }
                                                        }}
                                                        max='9999-12-31'
                                                        className="form-control"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-4 text-right mb-2">
                                                <div className='input-group-append '>
                                                    <button type="button" className="btn btn-primary ml-0" onClick={() => this.SearchLastBOEmployeesCashCuts()} style={{ backgroundColor: "rgb(233, 236, 239)", color: "rgb(73, 80, 87)", border: "1px solid rgb(206, 212, 218)" }}>
                                                        <i className="fa fa-search mr-2" aria-hidden="true" />
                                                        Buscar
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='card scrollTableClosures' >
                                            <table className="table table-striped table-hover" id="inData" >
                                                <thead className='sticky-headerPOS' style={{ backgroundColor: "white" }}>
                                                    <tr>
                                                        <th className="text-center">Folio Corte Suc.</th>
                                                        <th className="text-center">Fecha </th>
                                                        <th className="text-center">Código Sucursal</th>
                                                        <th className="text-center"></th>
                                                        {_user?.U_FMB_CounterRol === "manager" && <th className="text-center"></th>}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {!!simulateResult && simulateResult.length > 0 &&
                                                        simulateResult.map((cashCutBO) => {
                                                            return (
                                                                <tr >
                                                                    <td className="text-center">{cashCutBO.folio ?? ''}</td>
                                                                    <td className="text-center"> {cashCutBO.date ?? ''}</td>
                                                                    <td className="text-center">{cashCutBO.codeBO ?? ''}</td>

                                                                    <td className="text-center sticky-column">
                                                                        <button className="btn btn-active" onClick={() => this.GetCashCutBOByDate(cashCutBO.date)}
                                                                            style={{ backgroundColor: "#e9ecef", color: "#495057", border: "1px solid #ced4da", align: "right" }}>
                                                                            <i className="fa fa-file-text-o mr-2"></i>
                                                                            Ver Cortes
                                                                        </button>
                                                                    </td>
                                                                    {_user?.U_FMB_CounterRol === "manager" && (
                                                                        <td className="text-center">
                                                                            {cashCutBO?.Status === "O" && (
                                                                                <button className="btn btn-outline-success ml-2" onClick={() => this.branchCashCut(cashCutBO?.IdSession || "0")}> Cerrar Corte </button>
                                                                            )}
                                                                        </td>
                                                                    )}
                                                                </tr>
                                                            )
                                                        })
                                                    }
                                                    <tr className='noSearch hide'>
                                                        <td colSpan="7"></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            {/* Cortes monetarios APPS*/}
                            <div
                                className="w-100 table-scroll tab-pane "
                                id="Apps-CashCuts"
                                role="tabpanel"
                                aria-labelledby="nav-home-tab-Apps-CashCuts"
                                style={{ paddingTop: 5, border: "1px solid #00000020", borderTop: "none", borderRadius: "0.25rem" }}>
                                <div className="row m-1">
                                    <div className="col-xl-12 mb-4 mb-xl-0 responsive-row">
                                        {/* <div className='card scrollTableClosures' > */}
                                        <div className="modal-body">
                                            <div className="row m-1">
                                                <h3 className="modal-title ml-3 mb-2 mt-3" >Entradas y retiros</h3>
                                            </div>

                                            <div className="row p-1">
                                                <div className="col-12 col-md-4 mb-2 responsive-row">
                                                    <div className="input-group">
                                                        <div className="input-group-prepend">
                                                            <span className="input-group-text"><strong>Chofer: </strong></span>
                                                        </div>
                                                        <select
                                                            name="select"
                                                            className="form-control"
                                                            style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                                                            value={userSearch || ""}
                                                            onChange={(event) => this.ChangeUserToSearch(event.target.value)}
                                                        >
                                                            <option value="">Seleccionar</option>
                                                            {!!users && users.map((user, index) => {
                                                                return (
                                                                    <option key={index} value={user.USERID}>{user.U_NAME} - {user.E_Mail} </option>
                                                                )
                                                            })}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-12 col-md-4 mb-2 responsive-row">
                                                    <div className="input-group">
                                                        <div className="input-group-prepend">
                                                            <span className="input-group-text"><strong>Desde: </strong></span>
                                                        </div>
                                                        <input
                                                            type="date"
                                                            value={initialDate}
                                                            onChange={(event) => this.ChangeInitialDate(event)}
                                                            onBlur={() => this.ValidateInitialDate()}
                                                            onKeyPress={(ev) => {
                                                                if (ev.key === 'Enter') {
                                                                    this.SearchMovements();
                                                                }
                                                            }}
                                                            max={finalDate}
                                                            className="form-control"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-12 col-md-4 mb-2 responsive-row">
                                                    <div className="input-group">
                                                        <div className="input-group-prepend">
                                                            <span className="input-group-text"><strong>Hasta: </strong></span>
                                                        </div>
                                                        <input
                                                            type="date"
                                                            value={finalDate}
                                                            onChange={(event) => this.ChangeFinalDate(event)}
                                                            onBlur={() => this.ValidateFinalDate()}
                                                            onKeyPress={(ev) => {
                                                                if (ev.key === 'Enter') {
                                                                    this.SearchMovements();
                                                                }
                                                            }}
                                                            min={initialDate}
                                                            max='9999-12-31'
                                                            className="form-control"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-12 col-md-4 text-right mb-2">
                                                    <div className='input-group-append '>
                                                        <button type="button" className="btn btn-primary ml-0" onClick={() => this.SearchMovements()} style={{ backgroundColor: "rgb(233, 236, 239)", color: "rgb(73, 80, 87)", border: "1px solid rgb(206, 212, 218)" }}>
                                                            <i className="fa fa-search mr-2" aria-hidden="true" />
                                                            Buscar
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row m-1">
                                                <div className="col-xl-12 mb-4 mb-xl-0 responsive-row">
                                                    <section>
                                                        <ul className="nav nav-tabs" id="myTab" role="tablist">
                                                            <li className="nav-item waves-effect waves-light">
                                                                <a className="nav-link active" id="ingresos-tab" data-toggle="tab" href="#ingresos" role="tab" aria-controls="ingresos" aria-selected="true" onClick={() => this.GetMovementsCash(1)}><h6>Entradas</h6></a>
                                                            </li>
                                                            <li className="nav-item waves-effect waves-light">
                                                                <a className="nav-link" id="egresos-tab" data-toggle="tab" href="#egresos" role="tab" aria-controls="egresos" aria-selected="false" onClick={() => this.GetMovementsCash(2)}><h6>Salidas</h6></a>
                                                            </li>
                                                        </ul>
                                                        <div className="tab-content" id="myTabContent" style={{ border: "1px solid #dee2e6", borderTop: "none" }}>
                                                            {/* -------------------------------------INGRESOS--------------------------------------------------------- */}
                                                            <div className="tab-pane fade active show" id="ingresos" role="tabpanel" aria-labelledby="ingresos-tab">
                                                                <div className="row p-1">
                                                                    <div className="col-12 col-md-6 mb-2">
                                                                        <input
                                                                            type="text"
                                                                            className="form-control "
                                                                            placeholder="Buscar"
                                                                            id="inSearch"
                                                                            onKeyUp={() => this.DoSearch("inData", "inSearch")} />
                                                                    </div>
                                                                    <div className="col-12 col-md-6 mb-2">

                                                                    </div>
                                                                    {/* <div className="col-6 text-right" >
                                                                            <button type="button" className="btn btn-outline-success" onClick={() => { this.ShowHideMoneyMovements(true); this.ChangeActionMoneyMovements(1) }}>
                                                                                <i className="fa fa-plus-circle mr-2" aria-hidden="true" />
                                                                                Nueva entrada
                                                                            </button>
                                                                        </div> */}
                                                                </div>
                                                                <div className='scrollTable' >
                                                                    <table className="table table-striped table-hover" id="inData" >
                                                                        <thead>
                                                                            <tr>
                                                                                <th>N° Documento</th>
                                                                                <th>Consecutivo</th>
                                                                                <th>Fecha</th>
                                                                                <th>Hora</th>
                                                                                {/* <th className="text-center">Descripción</th> */}
                                                                                <th className="text-left">Tipo</th>
                                                                                <th>Monto</th>
                                                                                <th></th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {!!Movements && Movements.map((movement, index) => {
                                                                                return (
                                                                                    <tr key={`infresosWithdrawal${movement.docNum + index}`}>

                                                                                        <td><strong>{movement.folio ?? ''}</strong></td>
                                                                                        <td>{movement?.nextFolio ?? ''}</td>
                                                                                        <td>{moment(movement.docDate).format('YYYY-MM-DD')}</td>
                                                                                        <td>{/*moment(movement.docTime).format('LTS') ||*/ movement.docTime}</td>
                                                                                        {/* <td className="text-center">{movement.comments}</td> */}
                                                                                        <td className="text-left"><i className="fa fa-plus-circle" aria-hidden="true" style={{ color: "#28a745" }} /> {movement.pm_Name ? movement.pm_Name.toUpperCase() : ''}</td>
                                                                                        <td>{CURRENCY + ' ' + FORMAT_NUMBER.new(movement.docTotal)}</td>
                                                                                        <td>
                                                                                            <button className='btn btn-primary' onClick={() => this.PrintCashMovements("ChashIn", "80", movement)} style={{ backgroundColor: "rgb(233, 236, 239)", color: "rgb(73, 80, 87)", border: "1px solid rgb(206, 212, 218)" }}>
                                                                                                <i className="fa fa-print" aria-hidden="true"></i>
                                                                                            </button>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })}
                                                                            <tr className='noSearch hide'>
                                                                                <td colSpan="7"></td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                            {/* -------------------------------------EGRESOS----------------------------------------------- */}
                                                            <div className="tab-pane fade" id="egresos" role="tabpanel" aria-labelledby="egresos-tab">
                                                                <div className="row p-1">
                                                                    <div className="col-12 col-md-6 mb-2">
                                                                        <input
                                                                            type="text"
                                                                            className="form-control "
                                                                            placeholder="Buscar"
                                                                            id="outSearch"
                                                                            onKeyUp={() => this.DoSearch("outData", "outSearch")} />
                                                                    </div>
                                                                    <div className="col-12 col-md-6"></div>
                                                                    {/* <div className="col-6 text-right" >
                                                                            <button type="button" className="btn btn-outline-danger" onClick={() => { this.ShowHideMoneyMovements(true); this.ChangeActionMoneyMovements(2) }}>
                                                                                <i className="fa fa-minus-circle mr-2" aria-hidden="true" />
                                                                                Nueva salida
                                                                            </button>
                                                                        </div> */}
                                                                </div>
                                                                <div className='scrollTable' >
                                                                    <table className="table table-striped table-hover" id="outData">
                                                                        <thead>
                                                                            <tr>
                                                                                <th>N° Documento</th>
                                                                                <th>Consecutivo</th>
                                                                                <th>Fecha</th>
                                                                                <th>Hora</th>
                                                                                {/* <th className="text-center">Descripción</th> */}
                                                                                <th className="text-center">Tipo</th>
                                                                                <th>Monto</th>
                                                                                <th></th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {!!Movements && Movements.map((movement, index) => {
                                                                                return (
                                                                                    <tr key={`egresosWithdrawal${movement.docNum + index}`}>
                                                                                        <td><strong>{movement.folio}</strong></td>
                                                                                        <td>{movement?.nextFolio ?? ''}</td>
                                                                                        <td>{moment(movement.docDate).format('YYYY-MM-DD')}</td>
                                                                                        <td>{movement.docTime}</td>
                                                                                        {/* <td className="text-center">{movement.comments}</td> */}
                                                                                        <td className="text-center"><i className="fa fa-minus-circle" aria-hidden="true" style={{ color: "#dc3545" }} /> {movement.pm_Name ? movement.pm_Name.toUpperCase() : ''}</td>
                                                                                        <td>{CURRENCY + ' ' + FORMAT_NUMBER.new(movement.docTotal)}</td>
                                                                                        <td>
                                                                                            <button className='btn btn-primary' onClick={() => this.PrintCashMovements("ChashOut", "80", movement)} style={{ backgroundColor: "rgb(233, 236, 239)", color: "rgb(73, 80, 87)", border: "1px solid rgb(206, 212, 218)" }}>
                                                                                                <i className="fa fa-print" aria-hidden="true"></i>
                                                                                            </button>
                                                                                        </td>
                                                                                    </tr>
                                                                                )

                                                                            })}
                                                                            <tr className='noSearch hide'>
                                                                                <td colSpan="7"></td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </section>
                                                </div>
                                            </div>
                                        </div>
                                        {/* </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ClosureModal
                    CommentCloseDoc={CommentCloseDoc}
                    ChangeCommentCloseDoc={this.ChangeCommentCloseDoc}
                    BranchOfficeGeneralCut={this.BranchOfficeGeneralCut}
                />

                <ConsolidateDocsModal
                    responseBOC

                />

                <PdfViewer
                    DocsToPrint={docsToPrint}
                    TypeDoc={typeDocPrint}
                    EnableEditButton={false}
                    Editable={false}
                    ChangeEditableMode={() => { }}
                    EditableDocModel={{}}
                    RefreshDocModel={() => { }}
                    SaveChanges={() => { }}
                    UploadDoc={() => { }}
                    EditParam1={false}
                    ShowPDFViewer={this.CloseCreatedInvoiceActions}
                    CreateDocument={() => { }}
                    OpenMailModal={this.OpenSendMailModal}
                    ItsFirme={true}
                    user={_user}
                    Counter={true}
                    MailTools={mailTools}
                    printhide={printhide}
                    ShowFormatToPrint={this.ShowFormatToPrint}
                    idSessionSelected={this.state.idSessionSelected}
                    reprint={false}
                />


                <CashCutModal
                    ShowCashCutModal={this.ShowCashCutModal}
                    CashCut={cashCut}
                    ObjCharge={objCharge}
                    TotalCashCut={totalCashCut}
                    TotalAmountSales={totalAmountSales}
                    NumVentas={numSalesCashCut}
                    extraPaymentsCashCut={extraPaymentsCashCut}
                    moneyEntries={moneyEntries}
                    moneyOuts={moneyOuts}
                    headerCashCut={headerCashCut}
                    BranchOfficeGeneralCut={this.BranchOfficeGeneralCut}
                    CloseWorkShift={() => { }}
                    GotoDashboard={() => { }}
                    lastDaySession={true}
                    HideTotalCashCutsActions={true}
                    _user={_user}
                    blindCashCut={false}
                    BlindCutByIdSession={this.state.BlindCutByIdSession}
                    bankOptions={bankOptions}
                    showDepositOperations={this.state.showDepositOperations}
                />

                <ListModal
                    IdModal={"failCardCodes"}
                    HeaderTitle={'Socios información por corregir'}
                    Body={this.bodyFailCardCodes()}
                    CloseActions={() => {
                        $("#failCardCodes").modal("hide");
                        this.setState({
                            FailCardCodes: []
                        })

                    }}
                />

                {!!currentCashCut && (
                    <AppsCashCuts
                        type={1} // 0: COUNTER, 1: APPS
                        cashCut={currentCashCut}
                        cancel={this.CancelAppCashCut}
                        updateStatus={this.updateStatusCashCut}
                        bankOptions={bankOptions}
                    />
                )}


                {showWarningModal && (
                    <WarningModal
                        title={warningModel.title || "Advertencia"}
                        message={warningModel.message || "¿Seguro que deseas continuar?"}
                        btnAccept={warningModel.acceptMsg || "Continuar"}
                        btnCancel={warningModel.cancelMsg || "Cancelar"}
                        size={warningModel.size || "modal-lg"}
                        accept={warningModel.accept}
                        cancel={warningModel.cancel} />
                )}
            </div>
        );
    }

    bodyFailCardCodes = () => {
        const { FailCardCodes } = this.state
        return (
            <div className="container">
                <div className="row justify-content-around">
                    <div className="col-12">
                        <div className="w-100 table-scroll tab-pane fade show active " aria-labelledby="nav-home-tab-Contenido" style={{ marginBottom: 0, minheight: 400, maxHeight: 500 }}>
                            <table className="table response" style={{ marginBottom: 0 }}>
                                <tr>
                                    <td className="sticky-header table-header-yellow" style={{ textAlign: "center" }}>Código cliente (CardCode)</td>
                                </tr>
                                {FailCardCodes && FailCardCodes.length > 0 &&
                                    FailCardCodes.map((partner, index) => {
                                        return (
                                            <tr key={index}>
                                                <td className="text-center">{partner || ''}</td>

                                            </tr>
                                        )
                                    })}
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

const mapStateToProps = (store) => {
    return {
        notificationReducer: store.NotificationReducer,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        enableSpinner: (value) =>
            dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value }),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ClosuresView);


// export default ;
